

function InitializeCalendarWidgetMaker() {
    if ($('#calendar-embed-script-overlay').length == 0)
        return;            
    GetAllCalendarStylesFromCookie();
    GenerateCalendarRemoteScript();
}
function FetchLocalizedCalendarContent() {
    var url = '/widgets/economic-calendar-content';
    var lang = GetCalendarLangFromValue(window.CalendarDefaultLang);
    if (lang && lang !== '') {
        url = '/' + lang + url;
    }

    $.ajax({
        type: "POST",
        url: url,
        data: {
            lang: lang,
            DefaultTime: window.CalendarValues.calendarDefaultTime,
            DefaultTheme: window.CalendarDefaultStyle,
            IsShowEmbedButton: window.CalendarWidgetIsShowEmbedButton,
        },
        success: function (data) {
            var widgetContainers = document.getElementsByClassName('widget-content-container');
            if (widgetContainers.length > 0) {
                var widgetContainer = widgetContainers[0];
                widgetContainer.innerHTML = data.content;
                if (window.CalendarDefaultLang && window.CalendarDefaultLang !== '') {
                    window.CalendarValues.currentLangTwoDigit = lang;
                } else {
                    window.CalendarValues.currentLangTwoDigit = window.CalendarValues.currentPageLangTwoDigit;
                }
                InitializeCalendarValues();
                InitializeEconomicCalendar();
            }
        },
        error: function () {

        }
    })
}

function GetCalendarLangFromValue(value) {
    var ret = value;
    if (value === "browser") {
        ret = window.navigator.userLanguage || window.navigator.language;
        ret = ret.substring(0, 2);
    } else if (value === "page") {
        ret = window.CalendarValues.currentPageLangTwoDigit;
    }
    return ret;
}
function OnChangedCalendarWidgetLanguage(e) {
    OnChangedCalendarStyles();
    var value = e.value;
    value = GetCalendarLangFromValue(value);
    window.CalendarDefaultLang = value;
    FetchLocalizedCalendarContent();
}

function OnChangedDefaultTimeFrame(e) {
    var value = e.value;
    window.CalendarValues.calendarDefaultTime = value;
    OnChangedCalendarStyles();
    FetchCalendarContentByTimefrrame();
}

function OnChangeShowCalendarEmbedButton(e) {
    var isShowEmbedButton = $('#show-embed-button').prop("checked");
    window.CalendarWidgetIsShowEmbedButton = isShowEmbedButton;
    if (isShowEmbedButton) {
        $('.embed-button').show();
    } else {
        $('.embed-button').hide();
    }
    OnChangedCalendarStyles();
}

function RemoveDefaultClass() {
    $('.calc-widget-container .calendar-body').removeClass('plain');
    $('.calc-widget-container .calendar-body').removeClass('dark');
}

function OnCalendarChangedDefaultStyles(e) {
    window.CalendarDefaultStyle = e.value;
    RemoveDefaultClass();
    $('.calc-widget-container .calendar-body').addClass(window.CalendarDefaultStyle);
    OnChangedCalendarStyles();

}

function OnChangedCalendarStyles() {
    SaveAllCalendarStylesToCookie();
    GenerateCalendarRemoteScript();
}
function SaveAllCalendarStylesToCookie() {    
    var defaultTheme = document.querySelector('#calendar-widget-default-style-select');
    if (defaultTheme) {
        window.CalendarWidgetStyle.SetDefaultTheme(defaultTheme.value);
    }

    var defaultLang = document.querySelector('#calendar-widget-language-select');
    if (defaultLang) {        
        window.CalendarWidgetStyle.SetDefaultLang(defaultLang.value);
    }

    var defaultTime = document.querySelector('#calendar-widget-default-timeframe-select');
    if (defaultTime) {        
        window.CalendarWidgetStyle.SetDefaultTime(defaultTime.value);
    }
    var isShowEmbed = document.querySelector('#show-embed-button');
    if (isShowEmbed) {
        window.CalendarWidgetStyle.SetShowEmbed(isShowEmbed.checked);
    }
}

function GetAllCalendarStylesFromCookie() {
    var lang = '';
    var defaultTheme = window.CalendarWidgetStyle.GetDefaultTheme();
    if (!!defaultTheme) {
        var defaultThemeEl = document.querySelector('#calendar-widget-default-style-select');
        if (defaultThemeEl) {
            defaultThemeEl.value = defaultTheme;
            window.CalendarDefaultStyle = defaultTheme;
        }
    }

    var defaultLang = window.CalendarWidgetStyle.GetDefaultLang();
    if (!!defaultLang) {
        var defaultLangEl = document.querySelector('#calendar-widget-language-select');
        if (defaultLangEl) {
            defaultLangEl.value = defaultLang;
            window.CalendarDefaultLang = defaultLang;
        }
    }

    var defaultTime = window.CalendarWidgetStyle.GetDefaultTime();
    if (!!defaultTime) {
        var defaultTimeEl = document.querySelector('#calendar-widget-default-timeframe-select');
        if (defaultTimeEl) {
            defaultTimeEl.value = defaultTime;
            window.CalendarValues.calendarDefaultTime = defaultTime;
        }
    }

    var isShowEmbed = window.CalendarWidgetStyle.GetShowEmbed();
    if (!!isShowEmbed) {
        var isShowEmbedEl = document.querySelector('#show-embed-button');
        if (isShowEmbedEl) {
            isShowEmbedEl.checked = isShowEmbed === 'true';
            window.CalendarWidgetIsShowEmbedButton = isShowEmbed;
        }
    }
    FetchLocalizedCalendarContent();
}

function OnSetDefaultFilter() {
    OpenFilterModal(true);
}
// All countries
// length 252
var countriesAndCurrencies = [
    { "name": "Afghanistan", "code": "AF", "symbol": "؋", "currency": "AFN" },
    { "name": "Albania", "code": "AL", "symbol": "Lek", "currency": "ALL" },
    { "name": "Algeria", "code": "DZ", "symbol": "دج", "currency": "DZD" },
    { "name": "American Samoa", "code": "AS", "symbol": "$", "currency": "USD" },
    { "name": "Andorra", "code": "AD", "symbol": "€", "currency": "EUR" },
    { "name": "Angola", "code": "AO", "symbol": "Kz", "currency": "AOA" },
    { "name": "Antigua and Barbuda", "code": "AG", "symbol": "$", "currency": "XCD" },
    { "name": "Argentina", "code": "AR", "symbol": "$", "currency": "ARS" },
    { "name": "Armenia", "code": "AM", "symbol": "֏", "currency": "AMD" },
    { "name": "Aruba", "code": "AW", "symbol": "ƒ", "currency": "AWG" },
    { "name": "Australia", "code": "AU", "symbol": "$", "currency": "AUD" },
    { "name": "Austria", "code": "AT", "symbol": "€", "currency": "EUR" },
    { "name": "Azerbaijan", "code": "AZ", "symbol": "m", "currency": "AZN" },
    { "name": "Bahamas", "code": "BS", "symbol": "B$", "currency": "BSD" },
    { "name": "Bahrain", "code": "BH", "symbol": ".د.ب", "currency": "BHD" },
    { "name": "Bangladesh", "code": "BD", "symbol": "৳", "currency": "BDT" },
    { "name": "Barbados", "code": "BB", "symbol": "Bds$", "currency": "BBD" },
    { "name": "Belarus", "code": "BY", "symbol": "Br", "currency": "BYN" },
    { "name": "Belgium", "code": "BE", "symbol": "€", "currency": "EUR" },
    { "name": "Belize", "code": "BZ", "symbol": "$", "currency": "BZD" },
    { "name": "Benin", "code": "BJ", "symbol": "CFA", "currency": "XOF" },
    { "name": "Bermuda", "code": "BM", "symbol": "$", "currency": "BMD" },
    { "name": "Bhutan", "code": "BT", "symbol": "Nu.", "currency": "BTN" },
    { "name": "Bolivia", "code": "BO", "symbol": "Bs.", "currency": "BOB" },
    { "name": "Bosnia and Herzegovina", "code": "BA", "symbol": "KM", "currency": "BAM" },
    { "name": "Botswana", "code": "BW", "symbol": "P", "currency": "BWP" },
    { "name": "Brazil", "code": "BR", "symbol": "R$", "currency": "BRL" },
    { "name": "Brunei", "code": "BN", "symbol": "B$", "currency": "BND" },
    { "name": "Bulgaria", "code": "BG", "symbol": "Лв.", "currency": "BGN" },
    { "name": "Burkina Faso", "code": "BF", "symbol": "CFA", "currency": "XOF" },
    { "name": "Burundi", "code": "BI", "symbol": "FBu", "currency": "BIF" },
    { "name": "Cambodia", "code": "KH", "symbol": "KHR", "currency": "KHR" },
    { "name": "Cameroon", "code": "CM", "symbol": "FCFA", "currency": "XAF" },
    { "name": "Canada", "code": "CA", "symbol": "$", "currency": "CAD" },
    { "name": "Cape Verde", "code": "CV", "symbol": "$", "currency": "CVE" },
    { "name": "Cayman Islands", "code": "KY", "symbol": "$", "currency": "KYD" },
    { "name": "Central African Republic", "code": "CF", "symbol": "FCFA", "currency": "XAF" },
    { "name": "Chad", "code": "TD", "symbol": "FCFA", "currency": "XAF" },
    { "name": "Chile", "code": "CL", "symbol": "$", "currency": "CLP" },
    { "name": "China", "code": "CN", "symbol": "¥", "currency": "CNY" },
    { "name": "Colombia", "code": "CO", "symbol": "$", "currency": "COP" },
    { "name": "Comoros", "code": "KM", "symbol": "CF", "currency": "KMF" },
    { "name": "Congo", "code": "CG", "symbol": "FC", "currency": "XAF" },
    { "name": "Republic Of The Congo", "code": "CD", "symbol": "FC", "currency": "CDF" },
    { "name": "Costa Rica", "code": "CR", "symbol": "₡", "currency": "CRC" },
    { "name": "Ivory Coast", "code": "CI", "symbol": "CFA", "currency": "XOF" },
    { "name": "Croatia", "code": "HR", "symbol": "kn", "currency": "HRK" },
    { "name": "Cuba", "code": "CU", "symbol": "$", "currency": "CUP" },
    { "name": "Cyprus", "code": "CY", "symbol": "€", "currency": "EUR" },
    { "name": "Czech Republic", "code": "CZ", "symbol": "Kč", "currency": "CZK" },
    { "name": "Denmark", "code": "DK", "symbol": "Kr.", "currency": "DKK" },
    { "name": "Djibouti", "code": "DJ", "symbol": "Fdj", "currency": "DJF" },
    { "name": "Dominica", "code": "DM", "symbol": "$", "currency": "XCD" },
    { "name": "Dominican Republic", "code": "DO", "symbol": "$", "currency": "DOP" },
    { "name": "Ecuador", "code": "EC", "symbol": "$", "currency": "USD" },
    { "name": "Egypt", "code": "EG", "symbol": "ج.م", "currency": "EGP" },
    { "name": "El Salvador", "code": "SV", "symbol": "$", "currency": "USD" },
    { "name": "Equatorial Guinea", "code": "GQ", "symbol": "FCFA", "currency": "XAF" },
    { "name": "Eritrea", "code": "ER", "symbol": "Nfk", "currency": "ERN" },
    { "name": "Estonia", "code": "EE", "symbol": "€", "currency": "EUR" },
    { "name": "Ethiopia", "code": "ET", "symbol": "Nkf", "currency": "ETB" },
    { "name": "Faroe Islands", "code": "FO", "symbol": "Kr.", "currency": "DKK" },
    { "name": "Fiji", "code": "FJ", "symbol": "FJ$", "currency": "FJD" },
    { "name": "Finland", "code": "FI", "symbol": "€", "currency": "EUR" },
    { "name": "France", "code": "FR", "symbol": "€", "currency": "EUR" },
    { "name": "French Polynesia", "code": "PF", "symbol": "₣", "currency": "XPF" },
    { "name": "Gabon", "code": "GA", "symbol": "FCFA", "currency": "XAF" },
    { "name": "Gambia", "code": "GM", "symbol": "D", "currency": "GMD" },
    { "name": "Georgia", "code": "GE", "symbol": "ლ", "currency": "GEL" },
    { "name": "Germany", "code": "DE", "symbol": "€", "currency": "EUR" },
    { "name": "Ghana", "code": "GH", "symbol": "GH₵", "currency": "GHS" },
    { "name": "Greece", "code": "GR", "symbol": "€", "currency": "EUR" },
    { "name": "Greenland", "code": "GL", "symbol": "Kr.", "currency": "DKK" },
    { "name": "Grenada", "code": "GD", "symbol": "$", "currency": "XCD" },
    { "name": "Guam", "code": "GU", "symbol": "$", "currency": "USD" },
    { "name": "Guatemala", "code": "GT", "symbol": "Q", "currency": "GTQ" },
    { "name": "Guinea", "code": "GN", "symbol": "FG", "currency": "GNF" },
    { "name": "Guinea Bissau", "code": "GW", "symbol": "CFA", "currency": "XOF" },
    { "name": "Guyana", "code": "GY", "symbol": "$", "currency": "GYD" },
    { "name": "Haiti", "code": "HT", "symbol": "G", "currency": "HTG" },
    { "name": "Honduras", "code": "HN", "symbol": "L", "currency": "HNL" },
    { "name": "Hong Kong", "code": "HK", "symbol": "$", "currency": "HKD" },
    { "name": "Hungary", "code": "HU", "symbol": "Ft", "currency": "HUF" },
    { "name": "Iceland", "code": "IS", "symbol": "kr", "currency": "ISK" },
    { "name": "India", "code": "IN", "symbol": "₹", "currency": "INR" },
    { "name": "Indonesia", "code": "ID", "symbol": "Rp", "currency": "IDR" },
    { "name": "Iran", "code": "IR", "symbol": "﷼", "currency": "IRR" },
    { "name": "Iraq", "code": "IQ", "symbol": "د.ع", "currency": "IQD" },
    { "name": "Ireland", "code": "IE", "symbol": "€", "currency": "EUR" },
    { "name": "Isle of Man", "code": "IM", "symbol": "£", "currency": "GBP" },
    { "name": "Israel", "code": "IL", "symbol": "₪", "currency": "ILS" },
    { "name": "Italy", "code": "IT", "symbol": "€", "currency": "EUR" },
    { "name": "Jamaica", "code": "JM", "symbol": "J$", "currency": "JMD" },
    { "name": "Japan", "code": "JP", "symbol": "¥", "currency": "JPY" },
    { "name": "Jordan", "code": "JO", "symbol": "ا.د", "currency": "JOD" },
    { "name": "Kazakhstan", "code": "KZ", "symbol": "лв", "currency": "KZT" },
    { "name": "Kenya", "code": "KE", "symbol": "KSh", "currency": "KES" },
    { "name": "Kiribati", "code": "KI", "symbol": "$", "currency": "AUD" },
    { "name": "North Korea", "code": "KP", "symbol": "₩", "currency": "KPW" },
    { "name": "South Korea", "code": "KR", "symbol": "₩", "currency": "KRW" },
    { "name": "Kosovo", "code": "XK", "symbol": "€", "currency": "EUR" },
    { "name": "Kuwait", "code": "KW", "symbol": "ك.د", "currency": "KWD" },
    { "name": "Kyrgyzstan", "code": "KG", "symbol": "лв", "currency": "KGS" },
    { "name": "Laos", "code": "LA", "symbol": "₭", "currency": "LAK" },
    { "name": "Latvia", "code": "LV", "symbol": "€", "currency": "EUR" },
    { "name": "Lebanon", "code": "LB", "symbol": "£", "currency": "LBP" },
    { "name": "Lesotho", "code": "LS", "symbol": "L", "currency": "LSL" },
    { "name": "Liberia", "code": "LR", "symbol": "$", "currency": "LRD" },
    { "name": "Libya", "code": "LY", "symbol": "د.ل", "currency": "LYD" },
    { "name": "Liechtenstein", "code": "LI", "symbol": "CHf", "currency": "CHF" },
    { "name": "Lithuania", "code": "LT", "symbol": "€", "currency": "EUR" },
    { "name": "Luxembourg", "code": "LU", "symbol": "€", "currency": "EUR" },
    { "name": "Macau", "code": "MO", "symbol": "$", "currency": "MOP" },
    { "name": "Macedonia", "code": "MK", "symbol": "ден", "currency": "MKD" },
    { "name": "Madagascar", "code": "MG", "symbol": "Ar", "currency": "MGA" },
    { "name": "Malawi", "code": "MW", "symbol": "MK", "currency": "MWK" },
    { "name": "Malaysia", "code": "MY", "symbol": "RM", "currency": "MYR" },
    { "name": "Maldives", "code": "MV", "symbol": "Rf", "currency": "MVR" },
    { "name": "Mali", "code": "ML", "symbol": "CFA", "currency": "XOF" },
    { "name": "Malta", "code": "MT", "symbol": "€", "currency": "EUR" },
    { "name": "Marshall Islands", "code": "MH", "symbol": "$", "currency": "USD" },
    { "name": "Mauritania", "code": "MR", "symbol": "MRU", "currency": "MRO" },
    { "name": "Mauritius", "code": "MU", "symbol": "₨", "currency": "MUR" },
    { "name": "Mayotte", "code": "YT", "symbol": "€", "currency": "EUR" },
    { "name": "Mexico", "code": "MX", "symbol": "$", "currency": "MXN" },
    { "name": "Micronesia", "code": "FM", "symbol": "$", "currency": "USD" },
    { "name": "Moldova", "code": "MD", "symbol": "L", "currency": "MDL" },
    { "name": "Monaco", "code": "MC", "symbol": "€", "currency": "EUR" },
    { "name": "Mongolia", "code": "MN", "symbol": "₮", "currency": "MNT" },
    { "name": "Montenegro", "code": "ME", "symbol": "€", "currency": "EUR" },
    { "name": "Morocco", "code": "MA", "symbol": "DH", "currency": "MAD" },
    { "name": "Mozambique", "code": "MZ", "symbol": "MT", "currency": "MZN" },
    { "name": "Myanmar", "code": "MM", "symbol": "K", "currency": "MMK" },
    { "name": "Namibia", "code": "NA", "symbol": "$", "currency": "NAD" },
    { "name": "Nepal", "code": "NP", "symbol": "₨", "currency": "NPR" },
    { "name": "Netherlands", "code": "NL", "symbol": "€", "currency": "EUR" },
    { "name": "Netherlands Antilles", "code": "AN", "symbol": "NAf", "currency": "ANG" },
    { "name": "New Caledonia", "code": "NC", "symbol": "₣", "currency": "XPF" },
    { "name": "New Zealand", "code": "NZ", "symbol": "$", "currency": "NZD" },
    { "name": "Nicaragua", "code": "NI", "symbol": "C$", "currency": "NIO" },
    { "name": "Niger", "code": "NE", "symbol": "CFA", "currency": "XOF" },
    { "name": "Nigeria", "code": "NG", "symbol": "₦", "currency": "NGN" },
    { "name": "Northern Mariana Islands", "code": "MP", "symbol": "$", "currency": "USD" },
    { "name": "Norway", "code": "NO", "symbol": "kr", "currency": "NOK" },
    { "name": "Oman", "code": "OM", "symbol": ".ع.ر", "currency": "OMR" },
    { "name": "Pakistan", "code": "PK", "symbol": "₨", "currency": "PKR" },
    { "name": "Palau", "code": "PW", "symbol": "$", "currency": "USD" },
    { "name": "Palestine", "code": "PS", "symbol": "₪", "currency": "ILS" },
    { "name": "Panama", "code": "PA", "symbol": "B/.", "currency": "PAB" },
    { "name": "Papua New Guinea", "code": "PG", "symbol": "K", "currency": "PGK" },
    { "name": "Paraguay", "code": "PY", "symbol": "₲", "currency": "PYG" },
    { "name": "Peru", "code": "PE", "symbol": "S/.", "currency": "PEN" },
    { "name": "Philippines", "code": "PH", "symbol": "₱", "currency": "PHP" },
    { "name": "Poland", "code": "PL", "symbol": "zł", "currency": "PLN" },
    { "name": "Portugal", "code": "PT", "symbol": "€", "currency": "EUR" },
    { "name": "Puerto Rico", "code": "PR", "symbol": "$", "currency": "USD" },
    { "name": "Qatar", "code": "QA", "symbol": "ق.ر", "currency": "QAR" },
    { "name": "Romania", "code": "RO", "symbol": "lei", "currency": "RON" },
    { "name": "Russia", "code": "RU", "symbol": "₽", "currency": "RUB" },
    { "name": "Rwanda", "code": "RW", "symbol": "FRw", "currency": "RWF" },
    { "name": "St Kitts and Nevis", "code": "KN", "symbol": "$", "currency": "XCD" },
    { "name": "Saint Lucia", "code": "LC", "symbol": "$", "currency": "XCD" },
    { "name": "Saint Vincent and the Grenadines", "code": "VC", "symbol": "$", "currency": "XCD" },
    { "name": "Samoa", "code": "WS", "symbol": "SAT", "currency": "WST" },
    { "name": "San Marino", "code": "SM", "symbol": "€", "currency": "EUR" },
    { "name": "Sao Tome and Principe", "code": "ST", "symbol": "Db", "currency": "STD" },
    { "name": "Saudi Arabia", "code": "SA", "symbol": "﷼", "currency": "SAR" },
    { "name": "Senegal", "code": "SN", "symbol": "CFA", "currency": "XOF" },
    { "name": "Serbia", "code": "RS", "symbol": "din", "currency": "RSD" },
    { "name": "Seychelles", "code": "SC", "symbol": "SRe", "currency": "SCR" },
    { "name": "Sierra Leone", "code": "SL", "symbol": "Le", "currency": "SLL" },
    { "name": "Singapore", "code": "SG", "symbol": "$", "currency": "SGD" },
    { "name": "Slovakia", "code": "SK", "symbol": "€", "currency": "EUR" },
    { "name": "Slovenia", "code": "SI", "symbol": "€", "currency": "EUR" },
    { "name": "Solomon Islands", "code": "SB", "symbol": "Si$", "currency": "SBD" },
    { "name": "Somalia", "code": "SO", "symbol": "Sh.so.", "currency": "SOS" },
    { "name": "South Africa", "code": "ZA", "symbol": "R", "currency": "ZAR" },
    { "name": "South Sudan", "code": "SS", "symbol": "£", "currency": "SSP" },
    { "name": "Spain", "code": "ES", "symbol": "€", "currency": "EUR" },
    { "name": "Sri Lanka", "code": "LK", "symbol": "Rs", "currency": "LKR" },
    { "name": "Sudan", "code": "SD", "symbol": ".س.ج", "currency": "SDG" },
    { "name": "Suriname", "code": "SR", "symbol": "$", "currency": "SRD" },
    { "name": "Swaziland", "code": "SZ", "symbol": "E", "currency": "SZL" },
    { "name": "Sweden", "code": "SE", "symbol": "kr", "currency": "SEK" },
    { "name": "Switzerland", "code": "CH", "symbol": "CHf", "currency": "CHF" },
    { "name": "Syria", "code": "SY", "symbol": "LS", "currency": "SYP" },
    { "name": "Taiwan", "code": "TW", "symbol": "$", "currency": "TWD" },
    { "name": "Tajikistan", "code": "TJ", "symbol": "SM", "currency": "TJS" },
    { "name": "Tanzania", "code": "TZ", "symbol": "TSh", "currency": "TZS" },
    { "name": "Thailand", "code": "TH", "symbol": "฿", "currency": "THB" },
    { "name": "East Timor", "code": "TL", "symbol": "$", "currency": "USD" },
    { "name": "Togo", "code": "TG", "symbol": "CFA", "currency": "XOF" },
    { "name": "Tonga", "code": "TO", "symbol": "$", "currency": "TOP" },
    { "name": "Trinidad and Tobago", "code": "TT", "symbol": "$", "currency": "TTD" },
    { "name": "Tunisia", "code": "TN", "symbol": "ت.د", "currency": "TND" },
    { "name": "Turkey", "code": "TR", "symbol": "₺", "currency": "TRY" },
    { "name": "Turkmenistan", "code": "TM", "symbol": "T", "currency": "TMT" },
    { "name": "Uganda", "code": "UG", "symbol": "USh", "currency": "UGX" },
    { "name": "Ukraine", "code": "UA", "symbol": "₴", "currency": "UAH" },
    { "name": "United Arab Emirates", "code": "AE", "symbol": "إ.د", "currency": "AED" },
    { "name": "United Kingdom", "code": "GB", "symbol": "£", "currency": "GBP" },
    { "name": "United States", "code": "US", "symbol": "$", "currency": "USD" },
    { "name": "Uruguay", "code": "UY", "symbol": "$", "currency": "UYU" },
    { "name": "Uzbekistan", "code": "UZ", "symbol": "лв", "currency": "UZS" },
    { "name": "Vanuatu", "code": "VU", "symbol": "VT", "currency": "VUV" },
    { "name": "Venezuela", "code": "VE", "symbol": "Bs", "currency": "VEF" },
    { "name": "Vietnam", "code": "VN", "symbol": "₫", "currency": "VND" },
    { "name": "Virgin Islands, U.s.", "code": "VI", "symbol": "$", "currency": "USD" },
    { "name": "Yemen", "code": "YE", "symbol": "﷼", "currency": "YER" },
    { "name": "Zambia", "code": "ZM", "symbol": "ZK", "currency": "ZMW" },
    { "name": "Zimbabwe", "code": "ZW", "symbol": "$", "currency": "ZWL" },
    { "name": "European Union", "code": "EU", "symbol": "€", "currency": "EUR" }
];

var defaultCountries = ["AU", "CA", "CH", "CN", "DE", "FR", "IT", "ES", "US", "GB", "NZ", "JP", "EU"];

var defaultCurrencies = ["AUD", "CAD", "CHF", "CNY", "EUR", "GBP", "JPY", "NZD", "USD"];


var continentCountryList = {
    "Asia": ["AF", "AM", "AZ", "BH", "BD", "BT", "IO", "BN", "KH", "CN", "CX", "CC", "CY", "GE", "HK", "IN", "ID", "IR", "IQ", "IL", "JP", "JO", "KZ", "KP", "KR", "KW", "KG", "LA", "LB", "MO", "MY", "MV", "MN", "MM", "NP", "OM", "PK", "PS", "PH", "QA", "RU", "SA", "SG", "LK", "SY", "TW", "TJ", "TH", "TL", "TR", "TM", "AE", "UZ", "VN", "YE"],
    "Europe": ["AX", "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CZ", "DK", "EE", "FO", "FI", "FR", "DE", "GI", "GR", "GG", "VA", "HU", "IS", "IE", "IM", "IT", "JE", "XK", "LV", "LI", "LT", "LU", "MK", "MT", "MD", "MC", "ME", "NL", "NO", "PL", "PT", "RO", "SM", "RS", "CS", "SK", "SI", "ES", "SJ", "SE", "CH", "UA", "GB", "EU", "EU"],
    "Africa": ["DZ", "AO", "BJ", "BW", "BF", "BI", "CM", "CV", "CF", "TD", "KM", "CG", "CD", "CI", "DJ", "EG", "GQ", "ER", "ET", "GA", "GM", "GH", "GN", "GW", "KE", "LS", "LR", "LY", "MG", "MW", "ML", "MR", "MU", "YT", "MA", "MZ", "NA", "NE", "NG", "RE", "RW", "SH", "ST", "SN", "SC", "SL", "SO", "ZA", "SS", "SD", "SZ", "TZ", "TG", "TN", "UG", "EH", "ZM", "ZW"],
    "Oceania": ["AS", "AU", "CK", "FJ", "PF", "GU", "KI", "MH", "FM", "NR", "NC", "NZ", "NU", "NF", "MP", "PW", "PG", "PN", "WS", "SB", "TK", "TO", "TV", "VU", "WF"],
    "America": ["AI", "AG", "AR", "AW", "BS", "BB", "BZ", "BM", "BO", "BQ", "BR", "CA", "KY", "CL", "CO", "CR", "CU", "CW", "DM", "DO", "EC", "SV", "FK", "GF", "GL", "GD", "GP", "GT", "GY", "HT", "HN", "JM", "MQ", "MX", "MS", "AN", "NI", "PA", "PY", "PE", "PR", "BL", "KN", "LC", "MF", "PM", "VC", "SX", "SR", "TT", "TC", "US", "UM", "UY", "VE", "VG", "VI"],
    "Antarctica": ["AQ", "BV", "TF", "HM", "GS"]
}
var isFirstFetchedEventData = false;
var selectedFilter = "";
var fromDate = "";
var toDate = "";
var tmpFromDate = "";
var tmpToDate = "";
var currentEventDateCount = 0;
var impactOrder = { "HIGH": 0, "MEDIUM": 1, "LOW": 2, "NONE": 3 };
const IMPACTS = [{ key: "HIGH", text: "High" }, { key: "MEDIUM", text: "Medium" }, { key: "LOW", text: "Low" }, { key: "NONE", text: "None" }];
const SYMBOLS = [
    "ANG", "ARS", "AUD", "BRL", "CAD", "CHF", "CLP", "CNY", "COP", "CZK", "DKK", "EEK", "EUR", "GBP", "HKD", "HUF", "IDR", "INR",
    "ISK", "JPY", "KPW", "KRW", "MXN", "NOK", "NZD", "PEI", "PLN", "QAR", "ROL", "RUB", "SEK", "SGD", "TRY", "USD", "ZAR"
];

var selectedIMPACTS = [];
var tmpSelectedIMPACTS = [];
var currencyList = [];
var countryList = [];
var countryContinentList = [];
var eventDateDatas = [];
var isLiveNotification = false;
var isSmsNotification = false;
var isEmailNotification = false;
var turnOffNotificationSound = false;
var isLoggedIn = false;
var notificationBeforeMin = 0;
var isNotificationBefore = false;
var currentTimeZone = "";
var currentOriginalTimeZone = "";
var currentTimeFormat = "24";
var tmpCurrentTimeZone = "";
var tmpCurrentTimeFormat = "";

var currentDayType = "7_days";
var tmpCurrentDayType = "7_days";

var selectedCountries = [];
var tmpSelectedCountries = [];

var selectedCurrencies = [];
var tmpSelectedCurrencies = [];

var isMobile = false;

var timeSort = "asc";
var impactSort = "";
var timezones = [];
var chart;
var frontendType = '';
var calendarWidgetId = '';
var showMoreDays = 3;
var g_nearestTime = '';
var g_timeLeftCount = 0;
var previousRowTentative = false;
var calendarBody;
var calendarBodyHeight;
var calendarBodyWidth;
var desktopTableElement;
var modalDialogMinHeight = 800;
var currentDateList = ['today', 'tomorrow', 'yesterday', 'this_week', 'this_month', 'next_week', 'next_month', 'last_week', 'last_month', '7_days'];
var setDefaultFilter = false;
var defaultFilterImpacts = [];
var defaultFilterCountries = [];
var defaultFilterCurrencies = [];

var ecTheme = 'plain';
function findAncestor(el, sel) {
    while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel)));
    return el;
}

if ($(".calendar-body").length > 0) {

    if (!window.streamLink) {
        window.streamLink = "https://price-calendar-stream.cashbackforex.com";
    }

    window.calendarConnection = new signalR.HubConnectionBuilder()
        .withUrl(window.streamLink + "/" + "hubs/calendar", { accessTokenFactory: function () { return window.APIHelper.GetAccessTokenAsync(); } })
        .configureLogging(signalR.LogLevel.Warning)
        .withAutomaticReconnect()
        .build();

    window.calendarConnection.on('ReceiveMessage', function (msg, body) {
        if (msg == "events") {
            const newEvents = JSON.parse(body);
            HandleReceivedEvents(newEvents);
        }
    });

    window.calendarConnection.start();
}
window.lastInactiveTime = null;
document.addEventListener("visibilitychange", function () {
    if (!document.hidden && eventDateDatas) {
        for (var i = 0; i < eventDateDatas.length; i++) {
            if (!eventDateDatas[i].a && eventDateDatas[i].t != 1) break;
        }
        if (i < eventDateDatas.length) {
            const startTime = eventDateDatas[i].u;

            PullMissingEventDates(startTime - 1, parseInt((new Date()).getTime() / 1000));
        }
    }
});

function HandleReceivedEvents(newEvents) {
    var isRecreateHtml = false;

    for (var j = 0; j < newEvents.length; j++) {

        const updatedModel = newEvents[j];

        var isExistEventDate = false;

        var type = "update";
        for (var i = 0; i < eventDateDatas.length; i++) {
            if (eventDateDatas[i].cid === updatedModel.cid) {
                isExistEventDate = true;
                if (type === "delete") {
                    eventDateDatas.splice(i, 1);
                    isRecreateHtml = true;
                } else {
                    var oldActual = eventDateDatas[i].a;

                    eventDateDatas[i].a = updatedModel.a;
                    eventDateDatas[i].c = updatedModel.c;
                    eventDateDatas[i].p = updatedModel.p;
                    eventDateDatas[i].r = updatedModel.r;
                    eventDateDatas[i].av = updatedModel.av;
                    eventDateDatas[i].cv = updatedModel.cv;
                    eventDateDatas[i].pv = updatedModel.pv;
                    if (updatedModel.s)
                        eventDateDatas[i].s = updatedModel.s;
                    if (updatedModel.bs)
                        eventDateDatas[i].bs = updatedModel.bs;

                    var evt = eventDateDatas[i];
                    var rowId = '#EventDateRow_' + evt.cid;
                    var mobileRowId = '#Mobile_EventDateRow_' + evt.cid;

                    var unit = evt.f !== null ? evt.f.toString() : '';
                    unit = unit !== "NaN" ? unit : '';
                    var currency = evt.g !== null ? evt.g.toString() : '';
                    currency = currency !== "ZERO" && currency != "NaN" ? currency : '';
                    var consensus = evt.c !== null ? evt.c : '';
                    var actual = evt.a !== null ? evt.a : '';
                    var previous = evt.p !== null ? evt.p : '';
                    var revised = evt.r !== null ? evt.r : '';
                    var rise = evt.b;

                    var surpriseIcon = generateSurpriseIcon(actual, consensus, rise, evt.bs, evt.s, updatedModel.v);
                    $(rowId + ' .surprise_icon').html(surpriseIcon);

                    var actualHtml = generateActualHtml(actual, consensus, unit, currency, rise, false, updatedModel.av, updatedModel.e, evt.bs, updatedModel.v);
                    $(rowId + ' .actual_td').html(actualHtml);
                    $(mobileRowId + ' .actual_div').html(actualHtml);
                    var consensushtml = generationConsensusHtml(consensus, unit, currency, updatedModel.cv);
                    $(rowId + ' .consensus_div').html(consensushtml);
                    $(mobileRowId + ' .consensus_div').html(consensushtml);
                    var previousHtml = generatePreivousHtml(revised, previous, unit, currency, rise, updatedModel.rv, updatedModel.pv);
                    $(rowId + ' .previous_td').html(previousHtml);
                    $(mobileRowId + ' .previous_div').html(previousHtml);

                    var surpriseHtml = generateSurpriseHtml(actual, consensus, rise, evt.bs, evt.s, unit, currency, false, updatedModel.v);
                    $(rowId + ' .surprise_td').html(surpriseHtml);

                    var surpriseMobileHtml = generateSurpriseHtml(actual, consensus, rise, evt.bs, evt.s, unit, currency, true, updatedModel.v);
                    $(mobileRowId + ' .surprise_div').html(surpriseMobileHtml);

                    if (oldActual !== evt.a && evt.a !== 0 && evt.a !== '' && isCheckedImpact(evt.v) && isCheckedCountry(evt.d)) {
                        playNotificationSound();
                    }

                    if (eventDateDatas[i].u !== updatedModel.u || eventDateDatas[i].t !== updatedModel.t) {
                        isRecreateHtml = true;
                        eventDateDatas[i].u = updatedModel.u;
                        eventDateDatas[i].t = updatedModel.t;
                    }
                }

                break;
            }
        }
        if (!isExistEventDate) {
            eventDateDatas.push(updatedModel);
            isRecreateHtml = true;
        }
    }
    if (isRecreateHtml) {
        generateEventDateTableBody(eventDateDatas, false);
    } else {
        $('[data-toggle="popover-hover"]').popover({
            trigger: 'hover',
            template: '<div class="popover ecal-popover" role="tooltip">' +
                '<div class="arrow"></div>' +
                '<h3 class="popover-header"></h3>' +
                '<div class="popover-body"></div>' +
                '</div>'
        });
        $('[data-toggle=popover-hover]').click(function (event) {
            event.stopPropagation();
        });
        initBigSurpriseTooltip();
    }
}

function formatDateWith(date) {
    var date_format = $('#date-format').val();
    moment.locale('en');
    var str = moment(date).format(date_format.toUpperCase());
    return str;
}

function configureTimezoneSelect() {
    if (currentTimeZone === "") {
        currentTimeZone = moment.tz.guess();
        currentOriginalTimeZone = currentTimeZone;
    }
    const selectorOptions = moment.tz.names()
        .reduce(function (memo, tz) {
            memo.push({
                name: tz,
                offset: moment.tz(tz).utcOffset()
            });

            return memo;
        }, [])
        .sort(function (a, b) {
            return a.offset - b.offset
        })
        .reduce(function (memo, tz) {
            const timezone = tz.offset ? moment.tz(tz.name).format('Z') : '';
            var timezoneName = tz.name;
            if (timezoneName.length > 20) {
                timezoneName = timezoneName.substring(0, 20) + '...';
            }
            var option = '<option value="' + tz.name + '">(GMT' + timezone + ') ' + timezoneName + '</option>';
            return memo.concat(option);
        }, "");


    document.querySelector(".timezone-Selector").innerHTML = selectorOptions;

    $(".timezone-Selector").on("change", function (e) {
        e.target.value;
    });
    $('.timeformat-Selector').on("change", function (e) {
        tmpCurrentTimeFormat = e.target.value;
    });
}
function onChangeTimeZoneSelect() {
    tmpCurrentTimeZone = document.getElementById("timezoneSelector").value;
}
function onChangeTimeFormat() {
    tmpCurrentTimeFormat = document.getElementById("timeformatSelector").value;
}

function onRemoteParentMessage(event) {
    if (event) {
        if (event.data.type === 'onLayoutChange') {
            resetModalPosition(event.data.data);
        } else if (event.data.type === 'onScroll') {
            resetModalPosition(event.data.data);
            resetTableHeaderStickyPosition(event.data.data);
        } else if (event.data.type === 'runFunc') {
            var funcName = event.data.data.name;
            if (typeof (window[funcName]) == "function") {
                window[funcName].call(null);
            }
        }
    }
}

function resetModalPosition(event) {
    var modals = document.getElementsByClassName('modal');
    for (var i = 0; i < modals.length; i++) {
        var modal = modals[i];
        var offsetTop = event.scrollY + event.offsetTop;
        var lappedHeight = event.scrollY - offsetTop;
        if (lappedHeight < 0) {
            lappedHeight = 0;
        }
        var marginTop = lappedHeight;
        var height = event.height - event.offsetTop;
        if (event.offsetTop < 0) {
            height = event.height;
        }
        if (height < modalDialogMinHeight) {
            height = modalDialogMinHeight;
        }
        if (!modal.classList.contains('show')) {
            setModalTopAndHeight(modal, marginTop, height)
        } else {
            modal.setAttribute('next-height', height);
            modal.setAttribute('next-margin-top', marginTop);
        }
    }
}

function setModalTopAndHeight(modal, marginTop, height) {
    var modalContents = modal.getElementsByClassName('modal-dialog');
    modalContents[0].style.height = height + 'px';
    modalContents[0].style.minHeight = height + 'px';
    modalContents[0].style.marginTop = marginTop + 'px';
}

function resetModalHeightMarginTop(modal) {
    if (modal) {
        var nextHeight = modal.getAttribute('next-height');
        var nextMarginTop = modal.getAttribute('next-margin-top');
        if (nextHeight && nextMarginTop) {
            setModalTopAndHeight(modal, nextMarginTop, nextHeight);
        }
    }
}
function resetTableHeaderStickyPosition(event) {
    window.scroll(0, event.scrollY + event.offsetTop);
}

window.addEventListener('resize', function (event) {
    isMobile = window.matchMedia('screen and (max-width: 768px)').matches;
}, true);


function postModalStateMessageToParent(modalId, isOpen) {
    if (frontendType === 'Widget') {
        window.parent.postMessage({
            'type': 'modalState',
            'data': {
                'isOpen': isOpen,
                'modalId': modalId,
                'containerId': calendarWidgetId
            }
        }, "*");
    }
}
function sendComponentToRemote() {
    return new Promise(function (resolve, reject) {
        var menuHeader = document.getElementById('ec-menu-container');
        var menuHeaderHeight = getAbsoluteHeight(menuHeader);;
        postMessageToRemoteWidget({
            'type': 'resize',
            'data': {
                'targetHeight': calendarBodyHeight,
                'menuHeaderHeight': menuHeaderHeight,
                'containerId': calendarWidgetId
            }
        });


        sendPopoutButton();
        sendCreateStickyHeader('desktop-table-header-id');
        sendCreateStickyHeader('mobile-table-header-id');

        sendCreateStickyContent('eventDate_table_body', 'desktop');
        sendCreateStickyContent('mobile_eventDate_table_body', 'mobile');

        var dHeader = document.getElementById('desktop-table-header-id');
        var dComputedStyle = window.getComputedStyle(dHeader.parentElement.parentElement);
        var dDisplay = dComputedStyle.display;
        var mHeader = document.getElementById('mobile-table-header-id');
        var mComputedStyle = window.getComputedStyle(mHeader.parentElement.parentElement);
        var mDisplay = mComputedStyle.display;
        postMessageToRemoteWidget({
            'type': 'setStyle',
            'data': {
                id: 'desktop-table-header-id',
                containerId: calendarWidgetId,
                styles: [{
                    'key': 'display',
                    'value': dDisplay
                }]
            }
        });
        postMessageToRemoteWidget({
            'type': 'setStyle',
            'data': {
                id: 'mobile-table-header-id',
                containerId: calendarWidgetId,
                styles: [{
                    'key': 'display',
                    'value': mDisplay
                }]
            }
        });

        postMessageToRemoteWidget({
            'type': 'setSticky',
            'data': {
                containerId: calendarWidgetId
            }
        });
        return resolve(true);
    })
}
function InitializeEconomicCalendar() {
    calendarBody = document.querySelector('.calendar-body');
    if (calendarBody === null) return;

    var popout = document.querySelector('#popout-economic-calendar-id');
    if (popout) {
        var hash = location.hash;
        if (hash === '#popout') {
            popout.style.setProperty('display', 'none', 'important');
        }
    }

    $(document).on('click', 'td[data-trigger="open-detail"]', function (e) {
       
        var target = $(e.target);
        var tr = $(target).closest('tr');
        var cid = tr.attr('id').replace("EventDateRow_", "");
        var eid = tr.attr('eid');
        onClickTableRow(cid, eid);
    });

    var themeSwitcher = document.querySelectorAll('.calendar-body .lc-switch');
    if (themeSwitcher != null && themeSwitcher.length > 0) {

        var savedTheme = getCookie("current-ec-theme");
        if (savedTheme && savedTheme !== '')
            ecTheme = savedTheme;

        if (ecTheme == 'dark') {
            calendarBody.classList.remove('plain');
            calendarBody.classList.add('dark');

            for (var i = 0; i < themeSwitcher.length; i++) themeSwitcher[i].classList.remove('checked');
            
        } else {
            calendarBody.classList.remove('dark');
            calendarBody.classList.add('plain');

            for (var i = 0; i < themeSwitcher.length; i++) themeSwitcher[i].classList.add('checked');
        }
    }

    isFirstFetchedEventData = false;
    var savedTimeZone = getCookie('currentTimeZone');
    configureTimezoneSelect();
    if (savedTimeZone && savedTimeZone !== '') {
        currentTimeZone = savedTimeZone;
    }
    var savedTimeFormat = getCookie('currentTimeFormat');
    if (savedTimeFormat && savedTimeFormat !== '') {
        currentTimeFormat = savedTimeFormat;
    }
    isMobile = window.matchMedia('screen and (max-width: 768px)').matches;
    SetCurrentTHTime();
    var todayDate = new Date();
    todayDate = new Date(getDateFromUnix(moment(), 'YYYY-MM-DDTHH:mm:ss'));
    todayDate.setHours(0);
    todayDate.setMinutes(0);
    todayDate.setSeconds(0);
    todayDate.setMinutes(0);
    fromDate = formatDateWith(todayDate);
    toDate = formatDateWith(todayDate);
    var model = window.CalendarValues.calendarModel;
    if (model && model.Type) {
        frontendType = model.Type;
        if (model.ContainerId) {
            calendarWidgetId = model.ContainerId;
        }
    }

    loadTurnOffNotificationSoundFromCookie();
    updateSoundToggleIcon();

    var popoutEl = document.getElementById('popout-economic-calendar-id');
    if (popoutEl) {
        popoutEl.setAttribute('href', GenerateCalendarPopoutLink());
    }
    
    UpdateCanonicalLink();
    if (frontendType === 'Widget') {
        var widgetPopoutTitle = document.getElementById('ec-widget-popupout-title-id').innerHTML;
        var widgetTitle = document.getElementById('ec-widget-title-id').innerHTML;

        window.parent.postMessage({
            'type': 'setTitle',
            'data': {
                'title': widgetTitle,
                'popoutTitle': widgetPopoutTitle,
                'containerId': calendarWidgetId
            }
        }, "*")
        var resizeObserver = new ResizeObserver(function (entries) {

            var height = entries[0].target.clientHeight;
            var width = entries[0].target.clientWidth;
            if (height === calendarBodyHeight && width === calendarBodyWidth) return;
            calendarBodyHeight = height;
            calendarBodyWidth = width;
            sendComponentToRemote();


        })
        resizeObserver.observe(calendarBody)

        if (window.addEventListener) {
            window.addEventListener("message", onRemoteParentMessage, false);
        } else if (window.attachEvent) {
            window.attachEvent("onmessage", onRemoteParentMessage, false);
        }


    }
    $('#timezoneModal').on('show.bs.modal', function () {
        postModalStateMessageToParent('timezoneModal', true);
    });
    $('#timezoneModal').on('hidden.bs.modal', function (e) {
        postModalStateMessageToParent('timezoneModal', false);
        resetModalHeightMarginTop(e.target);
    });
    $("#filterModal").on('show.bs.modal', function () {
        postModalStateMessageToParent('filterModal', true);
    });
    $('#filterModal').on('hidden.bs.modal', function (e) {
        postModalStateMessageToParent('filterModal', false);
        resetModalHeightMarginTop(e.target);
    });
    $("#dateFilterModal").on('show.bs.modal', function () {
        postModalStateMessageToParent('dateFilterModal', true);
    });
    $('#dateFilterModal').on('hidden.bs.modal', function (e) {
        postModalStateMessageToParent('dateFilterModal', false);
        resetModalHeightMarginTop(e.target);
    });
    $("#eventDateDetail").on('show.bs.modal', function () {
        postModalStateMessageToParent('eventDateDetail', true);
    });
    $('#eventDateDetail').on('hidden.bs.modal', function (e) {
        postModalStateMessageToParent('eventDateDetail', false);
        resetModalHeightMarginTop(e.target);
        $('#event_historical_chart').html('');
        if (chart) {
            chart.destroy();
        }
    })
    loadCalendarDayType();

    
    LoadCalendarTimeFrame();

    if (window.CalendarValues.calendarModel
        && window.CalendarValues.calendarModel.Impacts
        && Array.isArray(window.CalendarValues.calendarModel.Impacts)) {
        selectedIMPACTS = window.CalendarValues.calendarModel.Impacts
            .filter(function (value, index) { return IMPACTS.findIndex(function (impact) { return impact.key == value.toUpperCase(); }) != -1; })
            .map(function (value) { return value.toUpperCase() });
    }
    if (selectedIMPACTS.length == 0) {
        selectedIMPACTS = IMPACTS.map(function (impact, index) { return impact.key; });
    }
    tmpSelectedIMPACTS = tmpSelectedIMPACTS.concat(selectedIMPACTS);

    SetSortStatus();
    getEventDates(fromDate, toDate, false, false, null);

    if (frontendType != "Article" && frontendType != "Home") {
        updateCalendarDatesEvery500();
    } else {
        updateCalendarDatesEvery2000OnHomePage();
    }
    
    updateCurrentTimeTH();

    var dateFormat = $('#date-format').val();
    $.fn.datepicker.setDefaults({
        inline: true,
        format: dateFormat,
        todayDate: todayDate,
        template: '<div class="datepicker-container">' +
            '<div class="datepicker-panel" data-view="years picker">' +
            '<ul>' +
            '<li data-view="years prev"><img src="/Content/dist/images/Calendar/caret_left.svg" style="width: 17px; height: 17px !important;"></li>' +
            '<li data-view="years current"></li>' +
            '<li data-view="years next"><img src="/Content/dist/images/Calendar/caret_right.svg" style="width: 17px; height: 17px !important;"></li>' +
            '</ul>' +
            '<ul data-view="years"></ul>' +
            '</div>' +
            '<div class="datepicker-panel" data-view="months picker">' +
            '<ul>' +
            '<li data-view="year prev"><img src="/Content/dist/images/Calendar/caret_left.svg" style="width: 17px; height: 17px !important;"></li>' +
            '<li data-view="year current"></li>' +
            '<li data-view="year next"><img src="/Content/dist/images/Calendar/caret_right.svg" style="width: 17px; height: 17px !important;"></li>' +
            '</ul>' +
            '<ul data-view="months"></ul>' +
            '</div>' +
            '<div class="datepicker-panel" data-view="days picker">' +
            '<ul>' +
            '<li data-view="month prev"><img src="/Content/dist/images/Calendar/caret_left.svg" style="width: 17px; height: 17px !important;"></li>' +
            '<li data-view="month current"></li>' +
            '<li data-view="month next"><img src="/Content/dist/images/Calendar/caret_right.svg" style="width: 17px; height: 17px !important;"></li>' +
            '</ul>' +
            '<ul data-view="week"></ul>' +
            '<ul data-view="days"></ul>' +
            '</div>' +
            '</div>'
    });
    $('#beginDatePicker').on('pick.datepicker', onChangedBeginDatePicker);
    $('#endDatePicker').on('pick.datepicker', onChangedEndDatePicker);

    $('.datePickerSideMenuItemButton').on('click', function (e) {
        $('.datePickerSideMenuItemButton').removeClass('active');
        e.target.classList.add('active');
        var type = e.target.getAttribute('data-type');
        OnClickedCalendarSideMenuItem(type);
        fromDate = tmpFromDate;
        toDate = tmpToDate;
        currentDayType = tmpCurrentDayType;
        SetCurrentDateState();
        getEventDates(fromDate, toDate, false, false, null);
    });

    InitCustomSelect();
    document.addEventListener("click", closeAllSelect);

    const buttonElements = document.getElementsByClassName('btn');
    [].forEach.call(buttonElements, function (el) {
        el.classList.remove("waves-effect");
        el.classList.remove("waves-light");
    });
}

function FetchCalendarContentByTimefrrame() {
    LoadCalendarTimeFrame();
    SetCurrentDateState();
    getEventDates(fromDate, toDate, false, false, null);
}

function LoadCalendarTimeFrame() {

    // get query params from url
    var urlParams = new URLSearchParams(window.location.search);
    var timeParam = urlParams.get('time');
    if (timeParam) {
        currentDayType = "custom";
        fromDate = formatDateWith(moment.unix(timeParam));
        toDate = fromDate;
        return;
    }

    if (window.CalendarValues.calendarDefaultTime) {
        var defaultDayType = window.CalendarValues.calendarDefaultTime;
        if (currentDateList.indexOf(defaultDayType) > -1) {
            currentDayType = window.CalendarValues.calendarDefaultTime;
        } else {
            currentDayType = '7_days';
        }
    }
    if (currentDayType) {
        var dateRange = GetDateRangeFromDayType(currentDayType);
        fromDate = dateRange.from;
        toDate = dateRange.to;
    }
}

document.addEventListener("DOMContentLoaded", function (event) {

    var calendarBody = document.querySelector('.calendar-body');
    if (calendarBody === null) return;

    InitializeEconomicCalendar();
    AddHrefToEmbedButtonToCalendar();
});
function InitCustomSelect() {
    var x, i, j, l, ll, selElmnt, a, b, c, ar, ari;
    x = document.getElementsByClassName("custom_select");
    l = x.length;

    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        if (ll === 0) {
            continue;
        }
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        var iHtml = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        a.innerHTML = iHtml;
        ar = document.createElement("DIV");
        ar.setAttribute("class", "select-arrow-container");
        ari = document.createElement("I");
        ari.setAttribute("class", "mdi mdi-chevron-down custom_select_arrow");
        ar.appendChild(ari);
        a.appendChild(ar);
        x[i].appendChild(a);
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 0; j < ll; j++) {
            c = document.createElement("DIV");
            var html = selElmnt.options[j].innerHTML;
            c.innerHTML = html;
            var val = selElmnt.options[j].value;
            c.setAttribute('value', val);
            if (j === 0) {
                var ar1 = document.createElement("DIV");
                ar1.setAttribute("class", "select-arrow1-container");
                var ari1 = document.createElement("I");
                ari1.setAttribute("class", "mdi mdi-check");
                ar1.appendChild(ari1);
                c.appendChild(ar1);
                c.setAttribute("class", "same-as-selected");
            }
            c.addEventListener("click", function (e) {
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                var val = this.getAttribute('value');
                for (i = 0; i < sl; i++) {
                    if (s.options[i].value == val) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        var ar1 = document.createElement("DIV");
                        ar1.setAttribute("class", "select-arrow-container");
                        var ari1 = document.createElement("I");
                        ari1.setAttribute("class", "mdi mdi-chevron-down custom_select_arrow");
                        ar1.appendChild(ari1);
                        h.appendChild(ar1);
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        yl = y.length;
                        for (k = 0; k < yl; k++) {
                            var child = y[k].getElementsByClassName('select-arrow1-container');
                            y[k].removeChild(child[0]);
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        var ar2 = document.createElement("DIV");
                        ar2.setAttribute("class", "select-arrow1-container");
                        var ari2 = document.createElement("I");
                        ari2.setAttribute("class", "mdi mdi-check");
                        ar2.appendChild(ari2);
                        this.appendChild(ar2);
                        s.value = val;
                        s.dispatchEvent(new Event('change'));
                        break;
                    }
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");

            var icon = this.querySelector('i');
            if (icon !== null) {
                if (icon.classList.contains("mdi-chevron-down")) {
                    icon.classList.remove("mdi-chevron-down");
                    icon.classList.add("mdi-chevron-up");
                } else {
                    icon.classList.add("mdi-chevron-down");
                    icon.classList.remove("mdi-chevron-up");
                }

            }
            var selectedDiv = this.nextSibling.getElementsByClassName('same-as-selected')[0];
            var topPos = selectedDiv.up;
            this.parentElement.offsetTop = topPos - 10;
        });
    }
}
function closeAllSelect(elmnt) {
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            var icon = y[i].querySelector('i');
            if (icon !== null) {
                icon.classList.remove("mdi-chevron-up");
                icon.classList.add("mdi-chevron-down");
            }
        }
    }
    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}
function configureCustomSelectValue(id, value) {
    var selectContainerElement = document.querySelector('#' + id).parentElement;
    var selectedContainer = selectContainerElement.getElementsByClassName('select-selected')[0];
    var listContainer = selectContainerElement.getElementsByClassName('select-items')[0];
    var listItems = listContainer.getElementsByTagName('div');
    y = listContainer.getElementsByClassName("same-as-selected");
    var yl = y.length;
    for (var k = 0; k < yl; k++) {
        var child = y[k].getElementsByClassName('select-arrow1-container');
        y[k].removeChild(child[0]);
        y[k].removeAttribute("class");
    }
    for (var i = 0; i < listItems.length; i++) {
        var val = listItems[i].getAttribute('value');
        if (val === value) {
            selectedContainer.selectedIndex = i;
            selectedContainer.innerHTML = listItems[i].innerHTML;
            var ar1 = document.createElement("DIV");
            ar1.setAttribute("class", "select-arrow-container");
            var ari1 = document.createElement("I");
            ari1.setAttribute("class", "mdi mdi-chevron-down custom_select_arrow");
            ar1.appendChild(ari1);
            selectedContainer.appendChild(ar1);

            listItems[i].setAttribute("class", "same-as-selected");
            var ar2 = document.createElement("DIV");
            ar2.setAttribute("class", "select-arrow1-container");
            var ari2 = document.createElement("I");
            ari2.setAttribute("class", "mdi mdi-check");
            ar2.appendChild(ari2);
            listItems[i].appendChild(ar2);
            var topPos = listContainer.scrollTop;
            listContainer.offsetTop = topPos;
            break;
        }
    }

}

function ShowLoadingTable(isAppend) {
    var mobileId = '#mobile_eventDate_table_body';
    var desktopId = '#eventDate_table_body';
    var loadingImage = '<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />';
    var mElm = $(mobileId + ' .loadingTr');
    var dElm = $(desktopId + ' .loadingTr');
    if (!mElm[0]) {
        if (!isAppend) {
            $(mobileId).html('');
        }
        $(mobileId).append('<tr class="loadingTr" style="height: 50px !important;"><td colspan="10">' + loadingImage + '</td></tr>');
    }
    if (!dElm[0]) {
        if (!isAppend) {
            $(desktopId).html('');
        }
        $(desktopId).append('<tr class="loadingTr" style="height: 50px !important;"><td colspan="10">' + loadingImage + '</td></tr>');
    }
}

function SetCurrentDateState() {
    var txt = GenerateDateRangeString(currentDayType, fromDate, toDate);
    $('#currentTimeButton').html(txt);

}

function SaveTimeZoneModal() {
    currentTimeZone = tmpCurrentTimeZone;
    currentTimeFormat = tmpCurrentTimeFormat;
    saveCurrentTimeConf();
    SetCurrentTHTime();
    if (currentDayType !== 'custom') {
        var dateRange = GetDateRangeFromDayType(currentDayType);
        fromDate = dateRange.from;
        toDate = dateRange.to;
    }
    getEventDates(fromDate, toDate, false, false, null);
}

function SaveFilterModal() {
    selectedIMPACTS = [].concat(tmpSelectedIMPACTS);
    selectedCountries = [].concat(tmpSelectedCountries);
    selectedCurrencies = [].concat(tmpSelectedCurrencies);

    if (frontendType != 'WidgetMaker' && frontendType != "ArticleMaker") {
        saveFiltersOnCookie();
        if (isLoggedIn) {
            saveFiltersAndLive();
        } else {
            generateEventDateTableBody(eventDateDatas, false);
        }
    } else {
        if (setDefaultFilter === true) {
            setDefaultFilter = false;

            defaultFilterCountries = selectedCountries;
            defaultFilterImpacts = selectedIMPACTS;
            defaultFilterCurrencies = selectedCurrencies;

            var impactSelectionHtml = '';
            IMPACTS.forEach(function (impact, index) {
                if (defaultFilterImpacts.includes(impact.key)) {
                    var imt = "";
                    var imtImg = impact.key;
                    if (impact.key === "LOW") {
                        imt = window.CalendarValues.impactLowString;
                    } else if (impact.key === "MEDIUM") {
                        imt = window.CalendarValues.impactMediumString;
                    } else if (impact.key === "HIGH") {
                        imt = window.CalendarValues.impactHighString;
                    } else if (impact.key === "NONE") {
                        imt = window.CalendarValues.impactNoneString;
                        imtImg = "low";
                    }
                    imtImg = imtImg.toLowerCase();
                    impactSelectionHtml += '<div class="ec-fx-impact"><img src="/Content/dist/images/Calendar/' + imtImg + '.png" style="width: 16px; height: 16px !important; margin-bottom: 0 !important;"><span class="font-13 ml-1">' + imt + '</span></div>';
                }
                
                
            });
            $("#calendar-widget-default-impacts-select").html(impactSelectionHtml);

            if (defaultFilterCountries.length > 0) {
                var countrySelectionHtml = '';
                const firstCountry = countryList.find(function (c, index) { return c.Code == defaultFilterCountries[0] });
                countrySelectionHtml += '<i class="flag flag-' + firstCountry.Code.toLowerCase() + ' mr-1"></i><span>' + firstCountry.Translation + '</span>'
                if (defaultFilterCountries.length > 1) countrySelectionHtml += '<span>, ... + ' + (defaultFilterCountries.length - 1) + ' others</span>';
                $("#calendar-widget-default-countries-select").html(countrySelectionHtml);
            } else {
                $("#calendar-widget-default-countries-select").html("Default");
            }
            

            GenerateCalendarRemoteScript();
        }

        generateEventDateTableBody(eventDateDatas, false);
    }
}


function SaveDateFilterModal() {
    fromDate = tmpFromDate;
    toDate = tmpToDate;
    currentDayType = tmpCurrentDayType;
    SetCurrentDateState();
    getEventDates(fromDate, toDate, false, false, null);
}

function SetSortStatus() {
    if (timeSort === "asc") {
        $('#timeSortTh div div').removeClass('ec-fx-th-sortable-img-desc');
        $('#timeSortTh div div').addClass('ec-fx-th-sortable-img-asc');
    } else if (timeSort === "desc") {
        $('#timeSortTh div div').addClass('ec-fx-th-sortable-img-desc');
        $('#timeSortTh div div').removeClass('ec-fx-th-sortable-img-asc');
    }
    if (impactSort === "asc") {
        $('#impactSortTh div div').removeClass('ec-fx-th-sortable-img-desc');
        $('#impactSortTh div div').addClass('ec-fx-th-sortable-img-asc');
    } else if (impactSort === "desc") {
        $('#impactSortTh div div').addClass('ec-fx-th-sortable-img-desc');
        $('#impactSortTh').removeClass('ec-fx-th-sortable-img-asc');
    } else {
        $('#impactSortTh div div').removeClass('ec-fx-th-sortable-img-desc');
        $('#impactSortTh div div').removeClass('ec-fx-th-sortable-img-asc');
    }
}

function SetCurrentTHTime() {
    var nowDate = new Date();
    var tt = getDateTimeFromDateString(nowDate.toISOString());
    $('#currentTimeTh').text(tt);
    $('#timezoneModalTitle').text(window.CalendarValues.currentTimeString + tt);

}
function OpenTimeZoneModal() {
    ConfigureTimeZoneModal();
    $('#timezoneModal').modal('show');
}

function onChangeDefaultViewChange() {
    var x = document.getElementById("mobileSelect").value;
    OnClickedCalendarSideMenuItem(x);
}

function ConfigureTimeZoneModal() {
    document.querySelector(".timezone-Selector").value = currentTimeZone;
    const event = new Event("change");
    document.querySelector(".timezone-Selector").dispatchEvent(event);
    $(".timezone-Selector").select();

    if (currentTimeFormat === "") {
        currentTimeFormat = "24";
    }
    document.querySelector(".timeformat-Selector").value = currentTimeFormat;
    const event1 = new Event("change");
    document.querySelector(".timeformat-Selector").dispatchEvent(event1);
    $(".timeformat-Selector").select();

    configureCustomSelectValue('timezoneSelector', currentTimeZone);
    configureCustomSelectValue('timeformatSelector', currentTimeFormat);
}
function OpenEvetDateRowDetailPage(ocountry, ocategory) {
    var loco = ocountry.toLowerCase();
    loco = loco.replaceAll(' ', '-');
    var loca = ocategory.toLowerCase();
    loca = loca.replaceAll(' ', '-');
    var lang = window.CalendarValues.currentLangTwoDigit;
    if (lang !== "") {
        lang = "/" + lang;
    }
    var getEventDateDetailByIdUrl = lang + "/api/calendar/te/event-detail/" + loco + '/' + loca;
    window.open(getEventDateDetailByIdUrl, '_blank');
}
function OpenFilterModal(setParam) {
    if (setParam === true) setDefaultFilter = true;
    else setDefaultFilter = false;

    if (setDefaultFilter) {
        if (defaultFilterImpacts && defaultFilterImpacts.length > 0) selectedIMPACTS = defaultFilterImpacts;
        if (defaultFilterCountries && defaultFilterCountries.length > 0) selectedCountries = defaultFilterCountries;
        if (defaultFilterCurrencies && defaultFilterCurrencies.length > 0) selectedCurrencies = defaultFilterCurrencies;
    }

    ConfigureFilterModal();
    $('#filterModal').modal('show');

    initImpactTooltip();
}

function ConfigureFilterModal() {
    var impactHtml = "";

    IMPACTS.forEach(function (impact, index) {
        var checked = isImpactSelected(impact.key);
        var checkedStr = checked ? "checked" : "";
        var imt = "";
        var imtImg = impact.key;
        if (impact.key === "LOW") {
            imt = window.CalendarValues.impactLowString;
        } else if (impact.key === "MEDIUM") {
            imt = window.CalendarValues.impactMediumString;
        } else if (impact.key === "HIGH") {
            imt = window.CalendarValues.impactHighString;
        } else if (impact.key === "NONE") {
            imt = window.CalendarValues.impactNoneString;
        }
        imtImg = imtImg.toLowerCase();

        if (frontendType == "Article" || frontendType == "Home") {
            impactHtml += '<div class="col-md-3 impact-content-item"><label class="ec-fx-impact-label"><input class="ec-fx-impact-' + impact.key.toLowerCase() + '" type = "checkbox" id = "chk_impact_' + impact.key + '" onclick=\"onImpactChecked(this)\" impact="' + impact.key + '" ' + checkedStr + ' />' +
                '<label class="ec-fx-impact-content" for="chk_impact_' + impact.key + '">' + '<div class="row ec-fx-impact ' + imtImg + '"><img src="/Content/dist/images/icons/impact-' + imtImg + '.png"><span class="font-13 ml-1">' + imt + '</span></div>' + '</label>' +
                '</label></div>';
            
        } else {
            if (imtImg == "none") imtImg = "low";
            impactHtml += '<div class="col-md-3 impact-content-item"><label class="ec-fx-impact-label"><input class="ec-fx-impact-' + impact.key.toLowerCase() + '" type = "checkbox" id = "chk_impact_' + impact.key + '" onclick=\"onImpactChecked(this)\" impact="' + impact.key + '" ' + checkedStr + ' />' +
                '<label class="ec-fx-impact-content" for="chk_impact_' + impact.key + '">' + '<div class="row ec-fx-impact"><img src="/Content/dist/images/Calendar/' + imtImg + '.png" style="width: 16px; height: 16px !important;"><span class="font-13 ml-1">' + imt + '</span></div>' + '</label>' +
                '</label></div>';
        }

        
    });
    $('#impact-content-section').html(impactHtml);
    tmpSelectedIMPACTS = [].concat(selectedIMPACTS);

    $('#country-section').html(filterAndGenerateCountryHtml(''));
    tmpSelectedCountries = [].concat(selectedCountries);

    $('#currency-section').html(filterAndGenerateCurrencyHtml(''));
    tmpSelectedCurrencies = [].concat(selectedCurrencies);
}

function GotoPrevDate() {
    GotoSomeDate(-1);
}

function GotoNextDate() {
    GotoSomeDate(1);
}

function GotoSomeDate(direction) {
    var fDate = DateObjectFromString(fromDate);
    var tDate = DateObjectFromString(toDate);
    const day = (tDate.getTime() - fDate.getTime()) / (1000 * 60 * 60 * 24);
    fDate.setDate(fDate.getDate() + (day + 1) * direction);
    tDate.setDate(tDate.getDate() + (day + 1) * direction);
    fromDate = formatDateWith(fDate);
    toDate = formatDateWith(tDate);
    currentDayType = GetDayTypeFromDateStrings(fromDate, toDate);
    SetCurrentDateState();
    getEventDates(fromDate, toDate, false, false, null);
}
function DateObjectFromString(strDate) {
    var date_format = $('#date-format').val();
    var to_date = moment(strDate, [date_format.toUpperCase()]);
    to_date = new Date(to_date.get('year'), to_date.get('month'), to_date.get('date'));
    to_date.setHours(0);
    to_date.setMinutes(0);
    to_date.setMilliseconds(0);
    return to_date;
}
function OpenCalendarTimeModal() {
    ConfiguredateFilterModal();
    $('#dateFilterModal').modal('show');

}

function ConfiguredateFilterModal() {
    tmpCurrentDayType = currentDayType;
    tmpFromDate = fromDate;
    tmpToDate = toDate;
    ConfigureDatePickerSection();
    SetDatePickerModalRangeInput();
    ConfigureDatePickerModalLeftSide();
}

function OnClickedCalendarSideMenuItem(type) {
    var range = GetDateRangeFromDayType(type);
    tmpFromDate = range.from;
    tmpToDate = range.to;
    SetDatePickerModalRangeInput();
    if (type !== "custom") {
        ConfigureDatePickerSection();
    }

}

function ConfigureDatePickerSection() {
    $('#beginDatePicker').datepicker('setDate', tmpFromDate);
    $('#endDatePicker').datepicker('setDate', tmpToDate);
}
function ConfigureLeftSideItemSectionForHtml() {
    var elements = $('.datePickerSideMenuItemButton');
    $.each(elements, function (i, element) {
        element.classList.remove('active');
        var val = element.getAttribute('data-type');
        if (val === tmpCurrentDayType) {
            element.classList.add('active');
        }
    });

    $('#mobileSelect').val(tmpCurrentDayType);
}
function GetCurrentDateTypeString(type) {
    var txt = "";
    switch (type) {
        case "today":
            txt = window.CalendarValues.todayString;
            break;
        case "tomorrow":
            txt = window.CalendarValues.tomorrowString;
            break;
        case "yesterday":
            txt = window.CalendarValues.yesterdayString;
            break;
        case "this_week":
            txt = window.CalendarValues.thisweekString;
            break;
        case "this_month":
            txt = window.CalendarValues.thismonthString;
            break;
        case "next_week":
            txt = window.CalendarValues.nextweekString;
            break;
        case "next_month":
            txt = window.CalendarValues.nextmonthString;
            break;
        case "last_week":
            txt = window.CalendarValues.lastweekString;
            break;
        case "last_month":
            txt = window.CalendarValues.lastmonthString;
            break;
        case "7_days":
            txt = window.CalendarValues._7daysString;
            break;
    }
    return txt;
}
function SetDatePickerModalRangeInput() {
    var totalText = GenerateDateRangeString(tmpCurrentDayType, tmpFromDate, tmpToDate);
    $('#dateRangeInput').val(totalText);
}

function GenerateDateRangeString(type, fDate, tDate) {
    var txt = GetCurrentDateTypeString(type);
    var format = "MMM DD, YYYY";
    txt = txt !== "" ? txt : "";
    var totalText = "";
    var startDate = getDateFromDateStringWithoutTimezone(DateObjectFromString(fDate), format);
    var endDate = getDateFromDateStringWithoutTimezone(DateObjectFromString(tDate), format);
    if (startDate === endDate) {
        if (txt === "") {
            return startDate;
        }
        return txt;
    } else {
        totalText = startDate + " - " + endDate;
    }
    return totalText;
}
function onChangedBeginDatePicker(e) {
    var tmpTDate = DateObjectFromString(tmpToDate);
    if (e.date > tmpTDate) {
        tmpFromDate = tmpToDate;
        ConfigureDatePickerSection();
        e.preventDefault();
        return;
    }

    var dateStr = getDateFromDateString(e.date, "ddd, MMM DD, YYYY");
    tmpFromDate = formatDateWith(e.date);
    $('#beginDateInput').val(dateStr);
    ConfigureDatePickerModalLeftSide();
}

function onChangedEndDatePicker(e) {
    var tmpFDate = DateObjectFromString(tmpFromDate);
    if (e.date < tmpFDate) {
        tmpToDate = tmpFromDate;
        ConfigureDatePickerSection();
        e.preventDefault();
        return;
    }
    var dateStr = getDateFromDateString(e.date, "ddd, MMM DD, YYYY");
    tmpToDate = formatDateWith(e.date);
    $('#endDateInput').val(dateStr);
    ConfigureDatePickerModalLeftSide();
}

function ConfigureDatePickerModalLeftSide() {
    tmpCurrentDayType = GetDayTypeFromDateStrings(tmpFromDate, tmpToDate);
    ConfigureLeftSideItemSectionForHtml();
    SetDatePickerModalRangeInput();
    ConfigureDefaultMobileSelect();

}
function ConfigureDefaultMobileSelect() {
    configureCustomSelectValue('mobileSelect', tmpCurrentDayType);
}
function GetDateRangeFromDayType(dayType) {
    var tmpCurrentDayType = dayType;
    var todayDate = new Date();
    moment.locale('en');
    todayDate = new Date(getDateFromDateString(moment(), 'YYYY-MM-DDTHH:mm:ss'));
    todayDate.setHours(0);
    todayDate.setMinutes(0);
    todayDate.setSeconds(0);
    todayDate.setMilliseconds(0);
    var tmpFromDate = formatDateWith(todayDate);
    var tmpToDate = tmpFromDate;
    const day = todayDate.getDay();
    switch (tmpCurrentDayType) {
        case "today":
            var todayDateStr = formatDateWith(todayDate);
            tmpFromDate = todayDateStr;
            tmpToDate = todayDateStr;
            break;
        case "tomorrow":
            todayDate.setDate(todayDate.getDate() + 1);
            var tmrDateStr = formatDateWith(todayDate);
            tmpFromDate = tmrDateStr;
            tmpToDate = tmrDateStr;
            break;
        case "yesterday":
            todayDate.setDate(todayDate.getDate() - 1);
            var ystDateStr = formatDateWith(todayDate);
            tmpFromDate = ystDateStr;
            tmpToDate = ystDateStr;
            break;
        case "this_week":
            todayDate.setDate(todayDate.getDate() - day);
            tmpFromDate = formatDateWith(todayDate);
            todayDate.setDate(todayDate.getDate() + 6);
            tmpToDate = formatDateWith(todayDate);
            break;
        case "this_month":
            todayDate.setDate(1);
            tmpFromDate = formatDateWith(todayDate);
            todayDate.setMonth(todayDate.getMonth() + 1);
            todayDate = todayDate.setDate(todayDate.getDate() - 1);
            tmpToDate = formatDateWith(todayDate);
            break;
        case "next_week":
            todayDate.setDate(todayDate.getDate() - day + 7);
            tmpFromDate = formatDateWith(todayDate);
            todayDate.setDate(todayDate.getDate() + 6);
            tmpToDate = formatDateWith(todayDate);
            break;
        case "next_month":
            todayDate.setDate(1);
            todayDate.setMonth(todayDate.getMonth() + 1);
            tmpFromDate = formatDateWith(todayDate);
            todayDate.setMonth(todayDate.getMonth() + 1);
            todayDate = todayDate.setDate(todayDate.getDate() - 1);
            tmpToDate = formatDateWith(todayDate);
            break;
        case "last_week":
            todayDate.setDate(todayDate.getDate() - day - 7);
            tmpFromDate = formatDateWith(todayDate);
            todayDate.setDate(todayDate.getDate() + 6);
            tmpToDate = formatDateWith(todayDate);
            break;
        case "last_month":
            todayDate.setDate(1);
            todayDate.setMonth(todayDate.getMonth() - 1);
            tmpFromDate = formatDateWith(todayDate);
            todayDate.setMonth(todayDate.getMonth() + 1);
            todayDate = todayDate.setDate(todayDate.getDate() - 1);
            tmpToDate = formatDateWith(todayDate);
            break;
        case "7_days":
            tmpFromDate = formatDateWith(todayDate);
            todayDate.setDate(todayDate.getDate() + 6);
            tmpToDate = formatDateWith(todayDate);
            break;
        default:
            break;
    }
    return { from: tmpFromDate, to: tmpToDate };
}
function GetDayTypeFromDateStrings(tmpFromDate, tmpToDate) {
    var todayDate = new Date();
    moment.locale('en');
    todayDate = new Date(getDateFromDateString(moment(), 'YYYY-MM-DDTHH:mm:ss'));
    todayDate.setHours(0);
    todayDate.setMinutes(0);
    todayDate.setSeconds(0);
    todayDate.setMilliseconds(0);
    const day = todayDate.getDay();
    var todayDateStr = formatDateWith(todayDate);
    var tmrDate = new Date(todayDate.getTime());
    var ystDate = new Date(todayDate.getTime());
    var thisWeekDate = new Date(todayDate.getTime());
    tmrDate.setDate(tmrDate.getDate() + 1);
    var tmrDateStr = formatDateWith(tmrDate);
    var ystDate = ystDate.setDate(ystDate.getDate() - 1);
    var ystDateStr = formatDateWith(ystDate);
    thisWeekDate.setDate(thisWeekDate.getDate() - day);
    var thisWeekFromDateStr = formatDateWith(thisWeekDate);
    thisWeekDate.setDate(thisWeekDate.getDate() + 7);
    var nextWeekFromDateStr = formatDateWith(thisWeekDate);
    thisWeekDate.setDate(thisWeekDate.getDate() - 14);
    var lastWeekFromDateStr = formatDateWith(thisWeekDate);
    thisWeekDate.setDate(thisWeekDate.getDate() + 6);
    var lastWeekToDateStr = formatDateWith(thisWeekDate);
    thisWeekDate.setDate(thisWeekDate.getDate() + 7);
    var thisWeekToDateStr = formatDateWith(thisWeekDate);
    thisWeekDate.setDate(thisWeekDate.getDate() + 7);
    var nextWeekToDateStr = formatDateWith(thisWeekDate);

    var thisMonthDate = new Date(todayDate.getTime());
    thisMonthDate.setDate(1);
    var thisMonthFromDateStr = formatDateWith(thisMonthDate);
    thisMonthDate.setMonth(thisMonthDate.getMonth() + 1);
    var nextMonthFromDateStr = formatDateWith(thisMonthDate);
    thisMonthDate.setMonth(thisMonthDate.getMonth() - 2);
    var lastMonthFromDateStr = formatDateWith(thisMonthDate);
    thisMonthDate.setMonth(thisMonthDate.getMonth() + 1);
    thisMonthDate.setDate(thisMonthDate.getDate() - 1);
    var lastMonthToDateStr = formatDateWith(thisMonthDate);
    thisMonthDate.setDate(thisMonthDate.getDate() + 1);
    thisMonthDate.setMonth(thisMonthDate.getMonth() + 1);
    thisMonthDate.setDate(thisMonthDate.getDate() - 1);
    var thisMonthToDateStr = formatDateWith(thisMonthDate);
    thisMonthDate.setDate(thisMonthDate.getDate() + 1);
    thisMonthDate.setMonth(thisMonthDate.getMonth() + 1);
    thisMonthDate.setDate(thisMonthDate.getDate() - 1);
    var nextMonthToDateStr = formatDateWith(thisMonthDate);

    var seven_date = todayDate.setDate(todayDate.getDate() + 6);
    var seven_dateStr = formatDateWith(seven_date);

    var tmpCurrentDayType = "custom";
    if (todayDateStr === tmpFromDate && todayDateStr === tmpToDate) {
        tmpCurrentDayType = "today"
    } else if (tmrDateStr === tmpFromDate && tmrDateStr === tmpToDate) {
        tmpCurrentDayType = "tomorrow";
    } else if (ystDateStr === tmpFromDate && ystDateStr === tmpToDate) {
        tmpCurrentDayType = "yesterday";
    } else if (thisWeekFromDateStr === tmpFromDate && thisWeekToDateStr === tmpToDate) {
        tmpCurrentDayType = "this_week";
    } else if (nextWeekFromDateStr === tmpFromDate && nextWeekToDateStr === tmpToDate) {
        tmpCurrentDayType = "next_week";
    } else if (lastWeekFromDateStr === tmpFromDate && lastWeekToDateStr === tmpToDate) {
        tmpCurrentDayType = "last_week";
    } else if (thisMonthFromDateStr === tmpFromDate && thisMonthToDateStr === tmpToDate) {
        tmpCurrentDayType = "this_month";
    } else if (lastMonthFromDateStr === tmpFromDate && lastMonthToDateStr === tmpToDate) {
        tmpCurrentDayType = "last_month";
    } else if (nextMonthFromDateStr === tmpFromDate && nextMonthToDateStr === tmpToDate) {
        tmpCurrentDayType = "next_month";
    } else if (todayDateStr === tmpFromDate && seven_dateStr === tmpToDate) {

        tmpCurrentDayType = "7_days";
    } else {
        tmpCurrentDayType = "custom";
    }
    return tmpCurrentDayType;
}

function onClickedTimeOnTableHeader() {

    if (timeSort === "") {
        timeSort === "asc";
    } else if (timeSort === "asc") {
        timeSort = "desc";
    } else if (timeSort === "desc") {
        timeSort = "asc";
    }
    impactSort = "";
    SetSortStatus();
    generateEventDateTableBody(eventDateDatas, false);
    sendMessageSortChanged('timeSortTh');
    sendMessageSortChanged('impactSortTh');
}

function onClickedImpactOnTableHeader() {
    if (impactSort === "") {
        impactSort = "asc";
    } else if (impactSort === "asc") {
        impactSort = "desc";
    } else if (impactSort === "desc") {
        impactSort = "asc";
    }
    SetSortStatus();
    generateEventDateTableBody(eventDateDatas, false);
    sendMessageSortChanged('impactSortTh');
}

function onImpactChecked(cb) {
    const symbol = cb.getAttribute("impact");
    if (cb.checked) {
        tmpSelectedIMPACTS.push(symbol);
    } else {
        for (var i = 0; i < tmpSelectedIMPACTS.length; i++) {
            if (tmpSelectedIMPACTS[i] === symbol) {
                tmpSelectedIMPACTS.splice(i, 1);
                break;
            }
        }
    }
}

function onCountryChecked(cb) {
    const countryCode = cb.getAttribute("country");
    if (cb.checked) {
        tmpSelectedCountries.push(countryCode);
    } else {
        for (var i = 0; i < tmpSelectedCountries.length; i++) {
            if (tmpSelectedCountries[i].toLowerCase() === countryCode.toLowerCase()) {
                tmpSelectedCountries.splice(i, 1);
                break;
            }
        }
    }
}

function onCurrencyChecked(cb) {
    const currencyCode = cb.getAttribute("currency");
    if (cb.checked) {
        tmpSelectedCurrencies.push(currencyCode);
    } else {
        for (var i = 0; i < tmpSelectedCurrencies.length; i++) {
            if (tmpSelectedCurrencies[i].toLowerCase() === currencyCode.toLowerCase()) {
                tmpSelectedCurrencies.splice(i, 1);
                break;
            }
        }
    }
}

function isImpactSelected(impact) {
    for (var i = 0; i < tmpSelectedIMPACTS.length; i++) {
        if (impact === tmpSelectedIMPACTS[i]) {
            return true;
        }
    }
    return false;
}
function isCountrySelected(country) {
    for (var i = 0; i < tmpSelectedCountries.length; i++) {
        if (country.toLowerCase() === tmpSelectedCountries[i].toLowerCase()) {
            return true;
        }
    }
    return false;
}

function isCurrencySelected(currency) {
    for (var i = 0; i < tmpSelectedCurrencies.length; i++) {
        if (currency.toLowerCase() === tmpSelectedCurrencies[i].toLowerCase()) {
            return true;
        }
    }
    return false;
}
function onInputLiveBeforeMinChange() {
    notificationBeforeMin = $('#input_live_before_min').val();
}
function onChangeBeforeLiveNotifcation(cb) {
    isNotificationBefore = cb.checked;
    $('#input_live_before_min').prop("disabled", !isNotificationBefore);
}

function impactCheckAll() {
    checkAllImpacts(true);
    tmpSelectedIMPACTS = [].concat(IMPACTS.map(function (im, i) { return im.key; }));
}
function impactUnCheckAll() {
    checkAllImpacts(false);
    tmpSelectedIMPACTS = [];
}
function checkAllImpacts(checked) {
    IMPACTS.forEach(function (impact, i) {
        $('#chk_impact_' + impact.key).prop('checked', checked);
    })
}
function countriesCheckAll() {
    checkAllCountries(true);
    tmpSelectedCountries = [].concat(countryList.map(function (c, i) { return c.Code; }));
}
function countriesUnCheckAll() {
    checkAllCountries(false);
    tmpSelectedCountries = [];
}
function checkAllCountries(checked) {
    countryList.forEach(function (c, i) {
        $('#chk_country_' + c.Code.toLowerCase()).prop('checked', checked);
    })
}

function currenciesCheckAll() {
    checkAllCurrencies(true);
    tmpSelectedCurrencies = [].concat(currencyList.map(function (c, i) { return c.Code; }));
}
function currenciesUnCheckAll() {
    checkAllCurrencies(false);
    tmpSelectedCurrencies = [];
}
function checkAllCurrencies(checked) {
    currencyList.forEach(function (c, i) {
        $('#chk_currency_' + c.Code.toLowerCase()).prop('checked', checked);
    })
}

function countriesDefault() {
    countryList.forEach(function (c, i) {
        if (defaultCountries.includes(c.Code)) {
            $('#chk_country_' + c.Code.toLowerCase()).prop('checked', true);
        } else {
            $('#chk_country_' + c.Code.toLowerCase()).prop('checked', false);
        }

    })
    tmpSelectedCountries = [].concat(defaultCountries);
}

function currenciesDefault() {
    currencyList.forEach(function (c, i) {
        if (defaultCurrencies.includes(c.Code)) {
            $('#chk_currency_' + c.Code.toLowerCase()).prop('checked', true);
        } else {
            $('#chk_currency_' + c.Code.toLowerCase()).prop('checked', false);
        }

    })
    tmpSelectedCurrencies = [].concat(defaultCurrencies);
}

function ResetFilterModal() {
    impactCheckAll();
    countriesDefault();
    currenciesDefault();

    SaveFilterModal();
}
function countriesContinent(continent) {
    const continentCountryCodes = continentCountryList[continent];
    const existCodes = [];
    countryList.forEach(function (c, i) {
        if (continentCountryCodes.includes(c.Code)) {
            $('#chk_country_' + c.Code.toLowerCase()).prop('checked', true);
            existCodes.push(c.Code);
        } else {
            $('#chk_country_' + c.Code.toLowerCase()).prop('checked', false);
        }
    });
    tmpSelectedCountries = [].concat(existCodes);
}

function showMoreLoadingImg(isShow) {
    var showMoreLoadingImgs = document.getElementsByClassName('show-more-loading-img');
    if (isShow) {
        for (var i = 0; i < showMoreLoadingImgs.length; i++) {
            showMoreLoadingImgs[i].style.display = 'block';
        }
    } else {
        for (var i = 0; i < showMoreLoadingImgs.length; i++) {
            showMoreLoadingImgs[i].style.display = 'none';
        }
    }
}
function onClickShowMore() {
    if (timeSort === "asc") {
        var to_date = DateObjectFromString(toDate);
        to_date.setDate(to_date.getDate() + 1);
        fromDateString = formatDateWith(to_date);
        to_date.setDate(to_date.getDate() + (showMoreDays - 1));
        toDateString = formatDateWith(to_date);
        toDate = toDateString;
        showMoreLoadingImg(true);
        getEventDates(fromDateString, toDateString, true, true, null);
    } else if (timeSort === "desc") {
        var from_date = DateObjectFromString(fromDate);
        from_date.setDate(from_date.getDate() - 1);
        toDateString = formatDateWith(from_date);
        from_date.setDate(from_date.getDate() - (showMoreDays - 1));
        fromDateString = formatDateWith(from_date);
        fromDate = fromDateString;
        getEventDates(fromDateString, toDateString, false, true, null);
        showMoreLoadingImg(true);
    }
    currentDayType = GetDayTypeFromDateStrings(fromDate, toDate);
    SetCurrentDateState();

}

function showLoading(isShow) {
    if (isShow) {
        $('#fx-loading-bar').removeClass('fx-loading-bar-hidden');
    } else {
        $('#fx-loading-bar').addClass('fx-loading-bar-hidden');
    }
}
function getDateFromUnix(time, format) {
    var langName = window.CalendarValues.currentLangTwoDigit;
    moment.locale(langName);
    var utcDate = moment.unix(time);
    var displayDate = utcDate.clone().tz(currentTimeZone);
    var dateMonthAsWord = displayDate.format(format);
    return dateMonthAsWord;
}
function getDateFromDateString(str, format) {
    var langName = window.CalendarValues.currentLangTwoDigit;
    moment.locale(langName);
    var utcDate = moment.utc(str, 'YYYY-MM-DDTHH:mm:ss');
    var displayDate = utcDate.clone().tz(currentTimeZone);
    var dateMonthAsWord = displayDate.format(format);
    return dateMonthAsWord;
}

function getDateFromDateStringWithoutTimezone(str, format) {
    var langName = window.CalendarValues.currentLangTwoDigit;
    moment.locale(langName);
    var utcDate = moment.utc(str, 'YYYY-MM-DDTHH:mm:ss');
    var displayDate = utcDate.clone().tz(currentOriginalTimeZone);
    var dateMonthAsWord = displayDate.format(format);
    return dateMonthAsWord;
}
function getDateTimeFromUnix(str) {
    var utcDate = moment.unix(str);
    var displayDate = utcDate.clone().tz(currentTimeZone);
    var format = "HH:mm";
    var is24Format = false;
    if (currentTimeFormat === "24") {
        is24Format = true;
    }
    if (!is24Format) {
        format = "h:mm"
        format = format + " A";
    }
    return displayDate.format(format);
}
function getDateTimeFromDateString(str) {
    var utcDate = moment.utc(str, 'YYYY-MM-DDTHH:mm:ss');
    var displayDate = utcDate.clone().tz(currentTimeZone);
    var format = "HH:mm";
    var is24Format = false;
    if (currentTimeFormat === "24") {
        is24Format = true;
    }
    if (!is24Format) {
        format = "h:mm"
        format = format + " A";
    }
    return displayDate.format(format);
}
function calcDiffTime(tick) {
    const date = new Date(tick * 1000);
    const currentDateTime = new Date();
    const diffTime = date.getTime() - currentDateTime.getTime();
    if (diffTime <= 0) {
        return "passed"
    } else {
        return getDateFromUnix(tick, "YYYY-MM-DDTHH:mm");
    }
}
function nearestTimeForFuture() {
    var filtered = filterEventDateDatas(eventDateDatas);
    filtered = orderBy(filtered, ['u'], ['asc']);
    for (var i = 0; i < filtered.length; i++) {
        var dateStr = calcDiffTime(filtered[i].u);
        if (dateStr !== 'passed') {
            return dateStr;
        }
    }
    return 'passed';
}
function calcTimeLeft(str) {
    const date = new Date(str * 1000);
    const currentDate = new Date();
    const diffTime = date.getTime() - currentDate.getTime();
    var langName = window.CalendarValues.currentLangTwoDigit;
    if (diffTime <= 0) {
        return "passed"
    } else {
        const diffSec = Math.floor(diffTime / 1000);
        const diffMin = Math.floor(diffSec / 60);
        const second = diffSec % 60;
        const minute = diffMin % 60;
        const hour = Math.floor((diffMin / 60) % 24);
        const day = Math.floor((diffMin / 60) / 24);
        if (day > 0) {
            return window.CalendarValues.widget_0D.replace('{0}', day);
        } else if (hour > 0) {
            var ret = window.CalendarValues.widget_0H.replace('{0}', hour);
            if (minute > 0) {
                ret = ret + " " + window.CalendarValues.widget_0m.replace('{0}', minute);
            }
            return ret;

        } else if (minute > 0) {
            return window.CalendarValues.widget_0m.replace('{0}', minute);
        } else if (second > 9) {
            return second + window.CalendarValues.siteSec;
        } else if (second > 0) {
            return '0' + second + window.CalendarValues.siteSec;
        } else {
            return "--";
        }
    }
    return diffTime;
}
function generateFlagCurrency(oname, name) {
    var countryInfo = getCountryInfoFromCountryNameJS(oname);
    var ret = {}
    var flag = '', currency = '';
    if (countryInfo.code && countryInfo.code !== '') {
        var countryCode = countryInfo.code;
        flag = "<div ><i class=\"flag flag-" + countryCode.toLowerCase() + "\" data-trigger=\"hover\" data-content=\"" + name + "\" data-placement=\"top\" data-toggle=\"popover-hover\"/></div>";
    }
    if (countryInfo.currency && countryInfo.currency !== '') {
        var currencyCode = countryInfo.currency;
        var html = "<div class=\"\" ><span data-trigger=\"hover\" data-content=\"" + currencyName + "\" data-placement=\"top\" data-toggle=\"popover-hover\">" + currencyCode + "</span></div>";
    }

}

function getCountryNameFromCode(code) {
    for (var i = 0; i < countryList.length; i++) {
        if (countryList[i].Code.toLowerCase() === code.toLowerCase()) {
            return countryList[i].Translation;
        }
    }
    return "";
}
function generateFlag(countryCode) {
    var countryName = getCountryNameFromCode(countryCode);
    var html = "<div ><i class=\"flag flag-" + countryCode.toLowerCase() + "\" data-trigger=\"hover\" data-content=\"" + countryName + "\" data-placement=\"top\" data-toggle=\"popover-hover\"/></div>";
    return html;
}
function generateCurrencyFromCountryName(ocountryName) {

    var countryInfo = getCountryInfoFromCountryNameJS(ocountryName);
    var currencyCode = countryInfo.currency;
    if (currencyCode === undefined || currencyCode === null || currencyCode === '') {
        return '';
    }
    var currencyName = getCurrencyNameFromCode(currencyCode);
    var html = "<div class=\"\" ><span data-trigger=\"hover\" data-content=\"" + currencyName + "\" data-placement=\"top\" data-toggle=\"popover-hover\">" + currencyCode + "</span></div>";
    return html;
}

function generateCurrency(currencyCode, countryCode, surpriseDir) {
    if (surpriseDir) {
        return '<div class="color-' + surpriseDir + '"> ' + currencyCode + '</div > ';
    } else {
        return '<div>' + currencyCode + '</div > ';
    }
}
function generateFlagFromCountryName(ocountryName) {
    var countryCode = getCountryInfoFromCountryNameJS(ocountryName).code;
    if (countryCode === undefined || countryCode === null || countryCode === '')
        return '';
    var name = getCountryNameFromCode(countryCode);
    var flag = "<div ><i class=\"flag flag-" + countryCode.toLowerCase() + "\" data-trigger=\"hover\" data-content=\"" + name + "\" data-placement=\"top\" data-toggle=\"popover-hover\"/></div>";
    return flag;
}

function getCountryInfoFromCountryNameJS(name) {
    if (countriesAndCurrencies && Array.isArray(countriesAndCurrencies)) {
        for (var i = 0; i < countriesAndCurrencies.length; i++) {
            if (countriesAndCurrencies[i].name.toLowerCase() === name.toLowerCase()) {
                return countriesAndCurrencies[i];
            }
        }
    }

    return {};
}
function getCurrencyNameFromCode(currencyCode) {
    for (var i = 0; i < currencyList.length; i++) {
        if (currencyList[i].Code.toLowerCase() === currencyCode.toLowerCase()) {
            return currencyList[i].Translation;
        }
    }
    return "";
}
// For Fxstreet
/*function generateUnitString(unit, content, potency, isMark) {
    if (content === '') {
        return '';
    }
    var prefixMark = '+';
    if (content < 0) {
        prefixMark = '-';
    } else if (content === 0) {
        prefixMark = '';
    } else if (isMark) {
        prefixMark = '+'
    } else {
        prefixMark = '';
    }
    contentStr = Math.abs(content);
    if (unit === '%') {
        return prefixMark + contentStr + unit;
    }
    var localePotency = "";
    if (potency === "K") {
        localePotency = window.CalendarValues.thousandShort;
    } else if (potency === "M") {
        localePotency = window.CalendarValues.millionShort;
    } else if (potency === "B") {
        localePotency = window.CalendarValues.billionShort;
    } else if (potency === "T") {
        localePotency = window.CalendarValues.trillionShort;
    }
    return prefixMark + unit + contentStr + localePotency
}*/
//For TE 
function generateUnitString(unit, content, currency, isMark, orgValStr) {
    if (content === '') {
        if (!!orgValStr) return orgValStr;
        return '';
    }
    var prefixMark = '+';
    if (content < 0) {
        prefixMark = '-';
    } else if (content === 0) {
        prefixMark = '';
    } else if (isMark) {
        prefixMark = '+'
    } else {
        prefixMark = '';
    }
    contentStr = Math.abs(content);
    if (unit === '%') {
        return prefixMark + contentStr + unit;
    }
    var localeUnit = "";
    if (unit === "K") {
        localeUnit = window.CalendarValues.thousandShort;
    } else if (unit === "M") {
        localeUnit = window.CalendarValues.millionShort;
    } else if (unit === "B") {
        localeUnit = window.CalendarValues.billionShort;
    } else if (unit === "T") {
        localeUnit = window.CalendarValues.trillionShort;
    } else {
        localeUnit = unit;
    }
    return currency + prefixMark + contentStr + localeUnit;
}
function generatePreivousHtml(revised, previous, unit, currency, rise, revisedValStr, valStr) {
    var diff = 0;
    var diffState = 0;

    var previousString = '';

    if (previous || valStr) {
        previousString = generateUnitString(unit, previous, currency, false, valStr);
    }

    if (!previousString) {
        return "&nbsp;";
    }

    if (revised) {

        diff = (parseFloat(previous) - parseFloat(revised)).toFixed(2);
        if (diff > 0) {
            diffState = -1;
        } else if (diff < 0) {
            diffState = 1
        } else {
            diffState = 0;
        }
        var riseValue = parseInt(rise, 10);
        if (riseValue <= 0) {
            diffState = -diffState;
        }
    }


    var previousFormat1 = window.CalendarValues.previousPoppoverTitle1;
    var previousFormat2 = window.CalendarValues.previousPoppoverTitle2;
    if (diffState !== 0) {
        var previousToolTip1 = previousFormat1.replace('{0}', generateUnitString(unit, diff, currency, true, valStr));
        var previousToolTip2 = previousFormat2.replace('{0}', generateUnitString(unit, parseFloat(revised), currency, false, revisedValStr)).replace('{1}', generateUnitString(unit, parseFloat(previous), currency, false, valStr));
        var previousTooltip = previousToolTip1 + "<br/><br/>" + previousToolTip2;
        var html = '<div class=\"d-flex justify-content-center align-items-center\"><div class=\"text-center ' + (diffState === 1 ? "ec-fx-revised-low" : diffState === -1 ? "ec-fx-revised-high" : "") + '\" data-trigger=\"hover\" data-toggle=\"popover-hover\" data-placement=\"top\" title=\"' + window.CalendarValues.revisedString + '\" data-content=\"' + previousTooltip + '\" data-html=\"true\">' + previousString + '</div></div>';
        return html;
    } else {
        var html = '<div class=\"text-center\">' + previousString + '</div>';
        return html;
    }
}
function generateActualHtml(actual, consensus, unit, currency, rise, mobile, valString, currencyCode, bigSurprise, impact) {
    var actualSection = generateUnitString(unit, actual, currency, false, valString);
    var actualState = 0;
    var actualDiff = 0;
    var surpriseClass = '';

    if (actual != '' && consensus != '') {
        var v2 = actual - consensus;
        actualDiff = v2.toFixed(2);
        if (actual > consensus) {
            actualState = 1;
        } else if (actual < consensus) {
            actualState = -1;
        } else {
            actualState = 0;
        }
        var riseValue = parseInt(rise, 10);
        if (riseValue <= 0) {
            actualState = -actualState;
        }

        if (bigSurprise && Math.abs(actualDiff) >= bigSurprise && (impact == 'MEDIUM' || impact == 'HIGH')) {
            surpriseClass = 'surprise big';
        }
    }

    if (!actualSection) {
        actualSection = "&nbsp;";
    }



    var actualFormat1 = window.CalendarValues.actualPoppoverTitle1;
    if (actualState !== 0) {
        var actualTooltip1 = actualFormat1.replace('{0}', generateUnitString(unit, actualDiff, currency, true));
        var actualTooltip2 = "";
        if (actualState === -1) {
            actualTooltip2 = window.CalendarValues.actualPoppoverTitle2_Worse.replace('{0}', currencyCode);
        } else {
            actualTooltip2 = window.CalendarValues.actualPoppoverTitle2_Better.replace('{0}', currencyCode);
        }
        var actualTooltip = actualTooltip1 + "<br/>" + actualTooltip2;

        if (surpriseClass !== '') {
            if (actualState == -1) actualTooltip += "<br/></br/>" + window.CalendarValues.bigSurpriseDownPopoverText;
            else actualTooltip += "<br/></br/>" + window.CalendarValues.bigSurpriseUpPopoverText;
        }
        if (!mobile) {
            var html = '<div class=\"d-flex justify-content-center align-items-center\"><div class=\"text-center ' + (actualState === 1 ? "ec-fx-revised-high" : actualState === -1 ? "ec-fx-revised-low" : actualState === 0 ? "ec-fx-revised-same" : "") + ' ' + surpriseClass + '\" data-toggle=\"popover-hover\" data-trigger=\"hover\" data-placement=\"top\" title=\"' + window.CalendarValues.actualString + '\" data-content=\"' + actualTooltip + '\" data-html=\"true\"><span>' + actualSection + '</span></div></div>';
            return html;
        } else {
            var html = '<div class=\"d-flex justify-content-center align-items-center\"><div class=\"text-center ' + (actualState === 1 ? "ec-fx-revised-high" : actualState === -1 ? "ec-fx-revised-low" : actualState === 0 ? "ec-fx-revised-same" : "") + ' ' + surpriseClass + '\"><span>' + actualSection + '</span></div></div>';
            return html;
        }

    } else {
        var html = '<div class=\"d-flex justify-content-center align-items-center\"><div class=\"text-center\"><span>' + actualSection + '</span></div></div>';
        return html;
    }
}
function generationConsensusHtml(consensus, unit, currency, valStr) {
    var consensusSection = generateUnitString(unit, consensus, currency, false, valStr);
    if (!consensusSection) consensusSection = '&nbsp;';
    return consensusSection;
}


function generateImpact(impact, isMobile) {
    var imt = "None";
    var imtImg = impact;
    if (impact === "LOW") {
        imt = window.CalendarValues.impactLowString;
    } else if (impact === "MEDIUM") {
        imt = window.CalendarValues.impactMediumString;
    } else if (impact === "HIGH") {
        imt = window.CalendarValues.impactHighString;
    } else if (impact === "NONE") {
        imt = window.CalendarValues.impactNoneString;
    }
    imtImg = imtImg.toLowerCase();
    if (frontendType === "Article" || frontendType === "Home") {
        return '<div class="row ec-fx-impact ' + imtImg + '"><img src="/content/dist/images/icons/impact-' + imtImg + '.png"></div>';
        if (!isMobile) {
            return '<div class="row ec-fx-impact ' + imtImg + '"><img src="/content/dist/images/icons/impact-' + imtImg + '.png"><span class="ml-1">' + imt + '</span></div>';
        } else {
            return '<div class="row ec-fx-impact ' + imtImg + '"><img src="/content/dist/images/icons/impact-' + imtImg + '.png"></div>';
        }
    } else {
        if (imtImg == "none") imtImg = "low";
        var html = '<div class="row ec-fx-impact ec-fx-impact-' + imtImg + '"><img style="width: 16px; height: 16px !important;" ><span class="ml-1">' + imt + '</span></div>';
        return html;
    }
}
function generateMobileImpact(impact) {
    var imt = "None";
    var imtImg = impact;
    if (impact === "LOW") {
        imt = window.CalendarValues.impactLowString;
    } else if (impact === "MEDIUM") {
        imt = window.CalendarValues.impactMediumString;
    } else if (impact === "HIGH") {
        imt = window.CalendarValues.impactHighString;
    } else if (impact === "NONE") {
        imt = window.CalendarValues.impactNoneString;
        imtImg = "low";
    }
    imtImg = imtImg.toLowerCase();
    var html = '<div class="ec-fx-impact ec-fx-impact-' + imtImg + '"><img style="width: 16px; height: 16px !important; min-width: 16px; min-height: 16px;"></div>';
    return html;
}

function generateNoEventRow(isMobile) {

    var html = '<tr class="ec-fx-table-event-row noEventRow"><td colspan=11 class="" style="height: 60px !important; font-weight: bold !important; text-align: center !important;">' + window.CalendarValues.noEventString + '</td></tr>';
    $('#eventDate_table_body').html(html);
    $('#mobile_eventDate_table_body').html(html);

}

function generateTentative(dateUtc, isSecondOrder, isTentative) {

    if (isSecondOrder) {
        const dateString = getDateTimeFromUnix(dateUtc);
        if (isTentative) {
            return '<div class="timeStringTentive"  data-toggle="popover-hover" data-trigger="hover" data-placement="top" data-content="' + window.CalendarValues.tentativeString + '">' + dateString + '?' + '</div>';
        } else {
            return '<div class="timeString">' + dateString + '</div>';
        }
    }
    return '';
}
function generateTentativeMobile(dateUtc, isTentative) {

    const dateString = getDateTimeFromUnix(dateUtc);
    if (isTentative) {
        return '<div class="timeStringTentive"  data-toggle="popover-hover" data-trigger="hover" data-placement="top" data-content="' + window.CalendarValues.tentativeString + '">' + dateString + '?' + '</div>';
    } else {
        return '<div class="timeString">' + dateString + '</div>';
    }
}
function ConvertImportanceToVolatility(importance) {
    if (importance === 3) {
        return "HIGH"
    } else if (importance === 2) {
        return "MEDIUM"
    } else if (importance === 1) {
        return "LOW"
    } else {
        return "NONE"
    }
}

function appendEventDateRow(list, idx, idxt, isAppend, tIdx, dateEventCount, nearestTime) {
    var odd = (currentEventDateCount + 1) % 2;
    var desktopHtml = '';
    var mobileHtml = '';
    if (idxt === 0 && list.length > 0) {
        var mobileDateTr = '<tr class="sticky-container"><th class="dateRowTr" colspan="9">' + getDateFromUnix(list[0].u, 'ddd, DD MMM') + '</th></tr>';
        mobileHtml += mobileDateTr;
    }
    $.each(list, function (indx, valueItem) {
        var unit = valueItem.f !== null ? valueItem.f.toString() : '';
        var currency = valueItem.g !== null ? valueItem.g.toString() : '';
        currency = currency !== "ZERO" && currency != "NaN" ? currency : '';
        unit = unit !== "NaN" ? unit : '';
        var dateUtc = valueItem.u;
        var consensus = valueItem.c !== null ? valueItem.c : '';
        var actual = valueItem.a !== null ? valueItem.a : '';
        var previous = valueItem.p !== null ? valueItem.p : '';
        var revised = valueItem.r !== null ? valueItem.r : '';

        var volatility = valueItem.v !== null && valueItem.v !== undefined ? valueItem.v : '';
        var name = valueItem.n;
        var isPreliminary = valueItem.h;
        var countryCode = valueItem.d;
        var currencyCode = valueItem.e;
        var oCountry = valueItem.oco;
        var oCategory = valueItem.oca;

        var rise = valueItem.b;
        var istentative = (valueItem.t === 1) && valueItem.a === null;
        var flagHtml;
        var surpriseHtml, surpriseHtmlMobile;
        if (frontendType == "Article" || frontendType == "Home") {
            var ownCountryList = ["EUR", "XCD", "XAF", "XOF", "AUD", "USD", "CHF", "ZAR", "RUB", "INR"];
            if (ownCountryList.includes(currencyCode)) {

                var localizedCountryName = getCountryNameFromCode(countryCode);
                if (!localizedCountryName) localizedCountryName = oCountry;

                name = localizedCountryName + " " + name;
            }
            surpriseHtml = generateSurpriseHtml(actual, consensus, rise, valueItem.bs, valueItem.s, unit, currency, false, volatility);
            surpriseHtmlMobile = generateSurpriseHtml(actual, consensus, rise, valueItem.bs, valueItem.s, unit, currency, true, volatility);
            flagHtml = generateSurpriseIcon(actual, consensus, rise, valueItem.bs, valueItem.s, volatility);
        } else {
            flagHtml = generateFlag(countryCode);
        }

        var color = getCalendarValueColor(actual, consensus, rise);

        var currencyHtml = generateCurrency(currencyCode, countryCode, color);

        var actualHtml = generateActualHtml(actual, consensus, unit, currency, rise, false, valueItem.av, currencyCode, valueItem.bs, volatility);
        var consensusHtml = generationConsensusHtml(consensus, unit, currency, valueItem.cv);
        var previousHtml = generatePreivousHtml(revised, previous, unit, currency, rise, valueItem.rv, valueItem.pv);

        var isFirst = tIdx === 0 || indx === 0;
        var isSecondOrder = isFirst || istentative;
        isSecondOrder = previousRowTentative || isSecondOrder;
        previousRowTentative = istentative;

        var orderString = isSecondOrder ? 'second' : 'not_second';
        
        var eventDateString = generateTentative(dateUtc, isSecondOrder, istentative);
        var eventDateStringMobile = generateTentativeMobile(dateUtc, istentative);
        if (isPreliminary === 1) {
            name += " (" + window.CalendarValues.preliminaryString + ")";
        }



        var timeDiff = calcDiffTime(dateUtc);
        var urgentClass = '';
        if (nearestTime !== 'passed' && timeDiff === nearestTime)
            urgentClass = 'event_date_urgent';


        var tr = '<tr isodd="odd_' + odd + '" class=\"ec-fx-table-event-row ' + urgentClass + '\" time="' + dateUtc + '" id=\"EventDateRow_' + valueItem.cid + '\" unit=\"' + unit + '\" potency=\"' + currency + '\" previous=\"' + (previous !== '' ? previous : '') + '\" consensus=\"' + consensus + '\" order="' + orderString + '" rise="' + rise + '" actual="' + actual + '" revised="' + revised + '" isTentative="' + istentative + '" isFirst="' + isFirst + '" eid="' + valueItem.eid + '">';
        tr = tr + ((idxt == 0 && indx == 0) ? ('<td order="first" class="dateTD" style="z-index: ' + (currentEventDateCount + 35) + '"><div  class="event_date_col" style="position: absolute; top: 0px; left: 50%; transform: translateX(-50%); text-align: center; font-weight: bold; width: calc(100% - 2px) !important; height: 50px; display: flex; display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: -moz-box;  -webkit-box-align: center; -webkit-flex-align: center; -ms-flex-align: center; -webkit-align-items: center; align-items: center; justify-content: center; word-break: break-all;z-index: ' + (currentEventDateCount + 100) + '">' + getDateFromUnix(dateUtc, 'ddd,<br> MMM DD') + '</div></div></td>') : '<td order="not_first" style="z-index: ' + (currentEventDateCount + 100) + '"><div></div></td>');
        tr = tr + '<td order="' + orderString + '" class="text-center">' + eventDateString + '</td>';
        
        var timeLeft = calcTimeLeft(dateUtc);

        tr = tr + '<td class=\"text-center p-0 checkmark-container time-left-col\" style="padding-top: 0px !important; padding-bottom: 0px !important;" data-trigger="open-detail">' + (timeLeft === 'passed' ? '--' : timeLeft) + '</td>';
        
        if (frontendType == "Article" || frontendType == "Home") {
            tr = tr + '<td data-trigger="open-detail" class="surprise_icon">' + flagHtml + '</td>';
        } else {
            tr = tr + '<td style="width: 26px !important"; data-trigger="open-detail" >' + flagHtml + '</td>';
        }
        tr = tr + '<td style="width: 38px !important; " data-trigger="open-detail" >' + currencyHtml + '</td>';
        if (frontendType == "Article" || frontendType == "Home") {
            tr = tr + '<td style="" data-trigger="open-detail" >' + generateImpact(volatility) + '</td>';
        }
        tr = tr + '<td data-trigger="open-detail" ><a class="event-name" href="/tools/economic-calendar/' + valueItem.n.toLowerCase().replace(/ /g, '-') + '-' + valueItem.eid + '" onclick="return false;">' + name + '</a></td>';
        if (frontendType != "Article" && frontendType != "Home") {
            tr = tr + '<td style="" data-trigger="open-detail" >' + generateImpact(volatility) + '</td>';
        }

        if ($("th[data-id=surprises]").length > 0) {
            tr = tr + '<td data-trigger="open-detail" class="surprise_td">' + surpriseHtml + '</td>';
        }

        tr = tr + '<td data-trigger="open-detail" style="margin: 0px; padding: 0px !important;" class="actual_td">' + actualHtml + '</td>';
        tr = tr + '<td data-trigger="open-detail" style="margin: 0px; padding: 0px !important;" class="consensus_td"><div class="text-center consensus_div">' + consensusHtml + '</div></td>';
        tr = tr + '<td data-trigger="open-detail" style="margin: 0px; padding: 0px !important;" class="previous_td">' + previousHtml + '</td>';
        tr = tr + '</tr>';
        desktopHtml += tr;
        if (dateEventCount === 1) {
            var spareTr = '<tr isodd="odd_' + odd + '" class="ec-fx-table-event-row spareRow ' + urgentClass + '"><td order="not_first" style="height: 20px !important;"/><td colspan=11 style=""><div style=\"width: 100%\"/></td></tr>';
            desktopHtml += spareTr;
        }

        if (frontendType != "Article" && frontendType != "Home") {

            var mobileTr = '<tr isodd="odd_' + odd + '" class=\"ec-fx-table-event-row ' + urgentClass + '\" time="' + dateUtc + '" id=\"Mobile_EventDateRow_' + valueItem.cid + '\" unit=\"' + unit + '\" potency=\"' + currency + '\" previous=\"' + (previous !== '' ? previous : '') + '\" consensus=\"' + consensus + '\" order="' + orderString + '" rise="' + rise + '" actual="' + actual + '" revised="' + revised + '" isTentative="' + istentative + '" isFirst="' + isFirst + '" eid="' + valueItem.eid + '">';

            mobileTr += '<td data-trigger="open-detail"  style="margin: 0px; padding: 0px;">';
            mobileTr += '<div class="d-flex flex-column h-100"><div style="flex: 1; white-space: nowrap;" class="d-flex justify-content-start align-items-center">' + eventDateStringMobile + '</div><div style="height:30px;" class="d-flex justify-content-start align-items-center actual_div">' + actualHtml + '</div></div>';
            mobileTr += '</td>';
            mobileTr += '<td data-trigger="open-detail"  style="margin: 0px; padding: 0px; text-align: center;">';
            mobileTr += '<div class="d-flex flex-column h-100"><div style="flex: 1;" class="d-flex justify-content-start align-items-center">' + flagHtml + '<div style="margin-left: 5px;"></div>' + currencyHtml + '</div><div style="height: 30px;" class="d-flex justify-content-start align-items-center consensus_div">' + consensusHtml + '</div></div>';
            mobileTr += '</td>';
            mobileTr += '<td data-trigger="open-detail"  style="margin: 0px; padding: 0px;">';
            mobileTr += '<div class="d-flex flex-column h-100"><div style="flex: 1;" class="d-flex justify-content-start align-items-center">' + generateMobileImpact(volatility) + '<div style="margin-left: 5px;"></div>' + name + '</div><div style="height: 30px;" class="d-flex justify-content-start align-items-center previous_div">' + previousHtml + '</div></div>';
            mobileTr += '</td></tr>';
        } else {
            var mobileTr = '<tr isodd="odd_' + odd + '" class=\"ec-fx-table-event-row ' + urgentClass + '\" time="' + dateUtc + '" id=\"Mobile_EventDateRow_' + valueItem.cid + '\" unit=\"' + unit + '\" potency=\"' + currency + '\" previous=\"' + (previous !== '' ? previous : '') + '\" consensus=\"' + consensus + '\" order="' + orderString + '" rise="' + rise + '" actual="' + actual + '" revised="' + revised + '" isTentative="' + istentative + '" isFirst="' + isFirst + '" eid="' + valueItem.eid + '">';

            mobileTr += '<td>';
            mobileTr += '<div class="d-flex flex-column align-items-center justify-content-center"><div style="flex: 1; white-space: nowrap;" class="d-flex justify-content-start align-items-center">' + eventDateStringMobile + '</div><div style="height:30px;" class="d-flex justify-content-start align-items-center">' + generateImpact(volatility, true) + '</div></div>';
            mobileTr += '</td>';
            mobileTr += '<td data-trigger="open-detail">';
            mobileTr +=
                '<div class="d-flex flex-column" style="gap: 8px;">' +
                    '<div class="d-flex justify-content-start align-items-center" style="gap: 24px">' +
                        '<div class="d-flex align-items-center" style="gap: 4px; font-weight: 600;">' + '<div class="surprise_icon">' + flagHtml + '</div>' + currencyHtml + '</div>' + 
                        '<div class="event-name">' + name + '</div>' + 
                    '</div>' +
                    '<div class="d-flex justify-content-between align-items-end" style="height: 30px;">' +
                        /*'<div class="d-flex flex-column align-items-center">' + 
                            '<div class="surprise_div">' + surpriseHtmlMobile + '</div>' +
                            '<span class="calendar-item-label">Surprise</span>' +
                        '</div>' + */
                        '<div class="d-flex flex-column align-items-center">' + 
                            '<div class="actual_div">' + actualHtml + '</div>' +
                            '<span class="calendar-item-label">Actual</span>' +
                        '</div>' + 
                        '<div class="d-flex flex-column align-items-center">' + 
                            '<div class="consensus_div">' + consensusHtml + '</div>' +
                            '<span class="calendar-item-label">Forecast</span>' +
                        '</div>' + 
                        '<div class="d-flex flex-column align-items-center">' + 
                            '<div class="previous_div">' + previousHtml + '</div>' +
                            '<span class="calendar-item-label">Previous</span>' +
                        '</div>' + 
                    '</div>'
                '</div>';
            mobileTr += '</td></tr>';
        }
        mobileHtml += mobileTr;
    });
    return { desktop: desktopHtml, mobile: mobileHtml };
}

function getCalendarValueColor(actual, forecast, rise) {
    if (actual == undefined || actual == '' || forecast == undefined || forecast == '') return '';

    var diff = actual - forecast;
    if (diff === 0) return '';
    diff = diff * (rise <= 0 ? -1 : 1);
    if (diff > 0) {
        return 'green';
    } else {
        return 'red';
    }
}

function generateSurpriseIcon(actual, forecast, rise, bigSurprise, surprise, impact) {

    if (impact != "HIGH" && impact != "MEDIUM") return '';
    if (actual == undefined || actual == '' || forecast == undefined || forecast == '') return '';


    var diff = actual - forecast;

    if (diff === 0) return '';

    var iconName = 'surprise';
    
    diff = diff * (rise <= 0 ? -1 : 1);
    if (diff > 0) {
        iconName += '-up.svg';
    } else {
        iconName += '-down.svg';
    }

    var html = '<img src="/content/dist/images/icons/' + iconName + '"/>';

    if (bigSurprise && Math.abs(diff) >= bigSurprise) {
        html += html;
    }

    return '<div class="surprise-icon">' + html + '</div>';
}


function generateSurpriseHtml(actual, forecast, rise, bigSurprise, surprise, unit, currency, isMobile, impact) {
    if (actual == undefined || actual === '' || forecast == undefined || forecast === '') return '';
    var diff = actual - forecast;
    if (diff == 0) return '<div></div>';

    var className = 'color';
    if (diff * (rise <= 0 ? -1 : 1) > 0) {
        className += '-green';
    } else {
        className += '-red';
    }
    var str = generateUnitString(unit, diff.toFixed(2), currency, false);


    if (!isMobile) {
        if (bigSurprise && Math.abs(diff) >= bigSurprise && (impact == 'MEDIUM' || impact == 'HIGH')) {
            return '<div class="surprise big"><span class="' + className + '">' + str + '</span></div>';
        } else {
            return '<div class="surprise"><span class="' + className + '">' + str + '</span></div>';
        }
    } else {
        if (bigSurprise && Math.abs(diff) >= bigSurprise && (impact == 'MEDIUM' || impact == 'HIGH')) {
            return '<div class="surprise big"><span class="' + className + '">' + str + '</span></div>';
        } else {
            return '<div class="surprise"><span class="' + className + '">' + str + '</span></div>';
        }
    }
    
    
}
function isCheckedImpact(impact) {
    var filterResults = selectedIMPACTS.filter(function (im) { var isSame = im === impact; return isSame; });

    if (filterResults.length > 0) {
        return true;
    }
    return false;
}
function isCheckedCountry(country) {
    if (country) {
        var filterResults = selectedCountries.filter(function (c) { return c.toLowerCase() === country.toLowerCase(); });
        if (filterResults.length > 0) {
            return true;
        }
    }
    return false;
}

function isCheckedCurrency(currency) {
    if (currency) {
        var filterResults = selectedCurrencies.filter(function (c) { return c.toLowerCase() === currency.toLowerCase(); });
        if (filterResults.length > 0) {
            return true;
        }
    }
    return false;
}

function convertCurrentDateWithTimeZone(date, timezone) {
    var date_format = $('#date-format').val();
    var mdate = moment(date, [date_format.toUpperCase()]);
    var utcDate = moment.tz(mdate, currentTimeZone).utc();
    var dstDate = utcDate.clone().tz(timezone);
    var dstDateStr = dstDate.format(date_format.toUpperCase());
    return dstDateStr;
}
function generateCountryCurrencyCode(data) {
    for (var i = 0; i < data.length; i++) {
        var d = data[i];
        var countryname = d.cn;
        var countryInfo = getCountryInfoFromCountryNameJS(countryname);
        d.d = countryInfo.code;
        d.e = countryInfo.currency;
        var vol = ConvertImportanceToVolatility(d.v);
        d.v = vol.toString();
    }
    return data;
}

function filterEventDateDatas(data) {
    var date_format = $('#date-format').val();
    var from_date = moment(fromDate, [date_format.toUpperCase()], currentTimeZone);
    from_date = new Date(from_date.get('year'), from_date.get('month'), from_date.get('date'));
    var to_date = moment(toDate, [date_format.toUpperCase()], currentTimeZone);
    to_date = new Date(to_date.get('year'), to_date.get('month'), to_date.get('date'));
    to_date.setDate(to_date.getDate() + 1);
    var filteredData = data.filter(function (d, index) {
        var utcDate = moment.unix(d.u);
        var displayDate = utcDate.clone().tz(currentTimeZone);
        var d_date = new Date(displayDate.get('year'),
            displayDate.get('month'),
            displayDate.get('date'),
            displayDate.get('hour'),
            displayDate.get('minute'),
            displayDate.get('second'));
        if ((d_date >= from_date)
            && (to_date > d_date)
            && isCheckedImpact(d.v)
            && isCheckedCountry(d.d))
        {
            return true;
        }
        return false;
    });
    return filteredData;
}
function generateEventDateTableBody(data, isAppend) {
    if (data === null) return;

    var filteredData = filterEventDateDatas(data);

    if (timeSort !== "") {
        filteredData = orderBy(filteredData, ['u'], [timeSort]);
    }
    if (filteredData.length === 0) {
        //TODO
    }

    
    const response = [];
    var grouped = filteredData.reduce(function (r, a) {
        var val = getDateFromUnix(a['u'], 'YYYY-MM-DD');
        var ret = [];
        if (r[val]) {
            ret = r[val]
        }
        ret.push(a);
        r[val] = ret;
        return r;
    }, {});

    var keys = Object.keys(grouped);
    for (var i = 0; i < keys.length; i++) {
        response.push({ key: keys[i], list: grouped[keys[i]] });
    }
    if (!isAppend) {
        currentEventDateCount = 0;
    }

    const nearestTime = nearestTimeForFuture();

    var desktopHtml = '';
    var mobileHtml = '';
    $(function () {
        $.each(response, function (i, item) {
            currentEventDateCount = currentEventDateCount + 1;
            if (impactSort === "") {
                const groupedTimeRows = [];
                var subgrouped = item.list.reduce(function (r, a) {
                    var val = getDateTimeFromUnix(a.u);
                    var ret = [];
                    if (r[val]) {
                        ret = r[val]
                    }
                    ret.push(a);
                    r[val] = ret;
                    return r;
                }, {});
                var subkeys = Object.keys(subgrouped);
                for (var i = 0; i < subkeys.length; i++) {
                    groupedTimeRows.push({ key: subkeys[i], list: subgrouped[subkeys[i]] });
                }
                $.each(groupedTimeRows, function (j, row) {
                    var ret = appendEventDateRow(row.list, i, j, isAppend, -1, item.list.length, nearestTime);
                    desktopHtml += ret.desktop;
                    mobileHtml += ret.mobile;
                });
            } else {

                var list = item.list.sort(function (a, b) {
                    var aV = impactOrder[a.v];
                    var bV = impactOrder[b.v];
                    if (impactSort === "asc") {
                        return aV - bV;
                    } else {
                        return bV - aV;
                    }
                });
                var ret = appendEventDateRow(list, i, 0, isAppend, 0, item.list.length, nearestTime);
                desktopHtml += ret.desktop;
                mobileHtml += ret.mobile;
            }

        });
        if (!isAppend) {
            $('#eventDate_table_body').html(desktopHtml);
            $('#mobile_eventDate_table_body').html(mobileHtml);
        } else {
            $('#eventDate_table_body').append(desktopHtml);
            $('#mobile_eventDate_table_body').append(mobileHtml);
        }


        $('[data-toggle="popover-hover"]').popover({
            trigger: 'hover',
            template: '<div class="popover ecal-popover" role="tooltip">' +
                '<div class="arrow"></div>' +
                '<h3 class="popover-header"></h3>' +
                '<div class="popover-body"></div>' +
                '</div>'
        });
        $('[data-toggle=popover-hover]').click(function (event) {
            event.stopPropagation();
        });
        $('.loadingTr').remove();
        if (filteredData.length === 0 && !isAppend) {
            generateNoEventRow();
        }

        initImpactTooltip();

        initBigSurpriseTooltip();

    });
}

function initEventDetailPageTime() {
    $('[data-action="event-date-time"').each(function (e) {
        var time = $(this).data('time');
        var date = getDateTimeFromUnix(time);
        $(this).text(date);
    });
    $('[data-action="event-date-link"').each(function (e) {
        var time = $(this).data('time');
        var date = getDateFromUnix(time, 'MMM DD, yyyy');
        $(this).text(date);
        var jumpTo = $(this).data('jump');
        $(this).attr('href', '/tools/economic-calendar?time=' + time + "&jumpTo=" + jumpTo);
    });
    $('[data-action="event-date-fulltime"').each(function (e) {
        var time = $(this).data('time');
        var date = getDateFromUnix(time, 'MMM DD, yyyy HH:mm');
        $(this).text(date);
    })
}

function initBigSurpriseTooltip() {
    $(".home-calendar .surprise.big span.color-green, .calendar-event-detail-view .surprise.big span.color-green").tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.bigSurpriseUpPopoverText
    });
    $(".home-calendar .surprise.big span.color-red, .calendar-event-detail-view .surprise.big span.color-red").tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.bigSurpriseDownPopoverText
    });

    $(".home-calendar .surprise.big span").click(function (event) {
        event.stopPropagation();
    });
}

function initImpactTooltip() {
    $(".home-calendar .ec-fx-impact.low, .calendar-event-detail-view .ec-fx-impact.low, .home-calendar .ec-fx-impact.none, .calendar-event-detail-view .ec-fx-impact.none").tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.impactLowPopoverText
    });
    $(".home-calendar .ec-fx-impact.medium, .calendar-event-detail-view .ec-fx-impact.medium").tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.impactMediumPopoverText
    });
    $(".home-calendar .ec-fx-impact.high, .calendar-event-detail-view .ec-fx-impact.high").tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.impactHighPopoverText
    });
}
function filterAndGenerateCountryHtml(keyword) {
    var orderedCountries = orderBy(countryList, ['Translation'], ['asc']);
    var html = "";
    $.each(orderedCountries, function (i, country) {
        var countryCode = country.Code.toLowerCase();
        var countryName = country.Translation;

        if (!countryName) countryName = countryCode;

        var checked = isCountrySelected(countryCode);
        var checkedStr = checked ? "checked" : "";
        if (countryName.toLowerCase().includes(keyword.toLowerCase())) {
            html += '<label class="col-md-4 country-content-item">' +
                '<input type = "checkbox" id = "chk_country_' + countryCode + '" onclick = "onCountryChecked(this)" country = "' + countryCode + '"' + checkedStr + '/>' +
                '<label class="h-100" style="" for="chk_country_' + countryCode + '">' +
                '<i class="flag flag-' + countryCode + '"></i><span class="font-13" > ' + countryName + '</span > ' +
                '</label>' +
                '</label >';
        } else {
            html += '';
        }


    });
    return html;
}

function filterAndGenerateCurrencyHtml(keyword) {
    var orderedCurrencies = orderBy(currencyList, ['Translation'], ['asc']);
    var html = "";
    $.each(orderedCurrencies, function (i, currency) {
        var currencyCode = currency.Code.toLowerCase();
        var currencyName = currency.Translation;

        if (!currencyName) currencyName = currencyCode;

        var checked = isCurrencySelected(currencyCode);
        var checkedStr = checked ? "checked" : "";
        if (currencyName.toLowerCase().includes(keyword.toLowerCase())) {
            html += '<label class="col-md-4 country-content-item">' +
                '<input type = "checkbox" id = "chk_currency_' + currencyCode + '" onclick = "onCurrencyChecked(this)" currency = "' + currencyCode + '"' + checkedStr + '/>' +
                '<label class="h-100" style="" for="chk_currency_' + currencyCode + '">' +
                '<span class="font-13" > ' + currencyName + '</span > ' +
                '</label>' +
                '</label >';
        } else {
            html += '';
        }


    });
    return html;
}

function onChangeCountryInput(e) {
    if ($('#tab-countries').hasClass('frn-tab-active')) {
        $('#country-section').html(filterAndGenerateCountryHtml(e.value));
    }
    else if ($("#tab-currencies").hasClass('frn-tab-active')) {
        $('#currency-section').html(filterAndGenerateCurrencyHtml(e.value));
    } else {
        $('#country-section').html(filterAndGenerateCountryHtml(e.value));
    }
    
}

function PullMissingEventDates(fromDate, toDate) {
    var currentUrl = window.CalendarValues.getMissingEventDatesUrl;
    
    if (!currentUrl) currentUrl = '/api/calendar/te/missing-eventdates/';
    if (window.CalendarValues.currentLangTwoDigit) {
        currentUrl = '/' + window.CalendarValues.currentLangTwoDigit + currentUrl;
    }

    var url = currentUrl + '?fromDate=' + fromDate + '&toDate=' + toDate;

    $.ajax({
        type: 'GET',
        url: url,
        success: function (data) {
            HandleReceivedEvents(data || []);
        }
    });
}

function getEventDates(fromDate, toDate, isAsc, isAppend, categories) {
    g_nearestTime = '';
    saveCalendarDayType();
    var currentUrl = window.CalendarValues.getEventDatesUrl;
    if (window.CalendarValues.currentLangTwoDigit) {
        currentUrl = '/' + window.CalendarValues.currentLangTwoDigit + currentUrl;
    }
   
    var url = currentUrl + '?fromDate=' + fromDate + '&toDate=' + toDate;
    var url = url + '&notFirst=' + isFirstFetchedEventData;
    var offset = moment.tz(currentTimeZone).utcOffset()
    url += '&currentOffset=' + offset;
    if (!isFirstFetchedEventData) {
        ShowLoadingTable(isAppend);
    } else {
        showLoading(true);
    }
    $.ajax({
        type: 'GET',
        url: url,
        success: function (data) {
            if (data === null) {
                showLoading(false);
                return;
            }
            var evtDates = [];
            // For Test
            if (data.EventDates != null) {
                evtDates = data.EventDates || [];
            } else {

                evtDates = data.TEEvents || [];
            }

            if (isAppend) {
                if (isAsc) {
                    eventDateDatas = [].concat(eventDateDatas, evtDates);
                } else {
                    eventDateDatas = [].concat(evtDates, eventDateDatas);
                }
            } else {
                eventDateDatas = [].concat(evtDates);
            }
            if (!isFirstFetchedEventData) {

                if (data.currentTimeZone) {
                    currentTimeZone = data.TimeZone;
                }
                if (currentTimeFormat === "") {
                    currentTimeFormat = data.is12hour ? "12" : "24";
                }
                currencyList = data.CurrencyList || [];

                countryList = data.CountryList || [];

                for (var i = 0; i < countriesAndCurrencies.length; i++) {
                    if (countryList.findIndex(function (c) { return c.Code == countriesAndCurrencies[i].code }) === -1) {
                        countryList.push({
                            Code: countriesAndCurrencies[i].code,
                            Translation: countriesAndCurrencies[i].name,
                            CultureCode: 'en'
                        });
                    }
                }

                for (var i = 0; i < countriesAndCurrencies.length; i++) {
                    if (currencyList.findIndex(function (c) { return c.Code == countriesAndCurrencies[i].currency }) === -1) {
                        currencyList.push({
                            Code: countriesAndCurrencies[i].currency,
                            Translation: countriesAndCurrencies[i].currency,
                            CultureCode: 'en'
                        });
                    }
                }

                if (window.CalendarValues.calendarModel
                    && window.CalendarValues.calendarModel.Impacts
                    && Array.isArray(window.CalendarValues.calendarModel.Countries)
                    && Array.isArray(window.CalendarValues.calendarModel.Currencies)) {
                    selectedCountries = window.CalendarValues.calendarModel.Countries
                        .map(function (v) { return v.toUpperCase(); })
                        .filter(function (v) { return countryList.findIndex(function (c) { return c.Code === v }) != -1 });

                    selectedCurrencies = window.CalendarValues.calendarModel.Currencies
                        .map(function (v) { return v.toUpperCase(); })
                        .filter(function (v) { return currencyList.findIndex(function (c) { return c.Code === v }) != -1 });

                }
                if (selectedCountries.length == 0) {
                    selectedCountries = defaultCountries;
                }
                tmpSelectedCountries = [].concat(selectedCountries);

                if (selectedCurrencies.length == 0) {
                    selectedCurrencies = defaultCurrencies;
                }
                tmpSelectedCurrencies = [].concat(selectedCurrencies);

                isFirstFetchedEventData = true;

                if (frontendType != "ArticleMaker" && frontendType != "WidgetMaker") {
                    if (isLoggedIn) {
                        setUserFiltersFromData(data);
                    } else {
                        getFiltersFromCookie();
                    }
                }
                if (data.months
                    && data.monthsShorts
                    && data.weekdays
                    && data.weekdaysShorts
                    && data.weekdaysMins
                ) {
                    setLocaleMoment(data);
                    setLocaleDatePicker(data);
                }

            }
            SetCurrentDateState();
            generateEventDateTableBody(evtDates, isAppend);
            showMoreLoadingImg(false);
            showLoading(false);

            if (!isAppend && frontendType != "Home") {
                scollToUrgentEvents();
            }
        },
        error: function (error) {
            showLoading(false);
        }
    });
}

function scollToUrgentEvents() {

    // get url params
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('jumpTo')) {
        var jumpTo = urlParams.get('jumpTo');
        
        setTimeout(function () {
            var selector = "#eventDate_table_body #EventDateRow_" + jumpTo;
            if (isMobile) selector = "#mobile_eventDate_table_body  #Mobile_EventDateRow_" + jumpTo;
            if ($(selector).length > 0) {
                $(selector).addClass('highlighted');
                $('html, body').animate({ scrollTop: $(selector).offset().top - 100 }, 300);
            }
        }, 500);
        
    } else {

        setTimeout(function () {
            var selector = "#eventDate_table_body tr.event_date_urgent:first";
            if (isMobile) selector = "#mobile_eventDate_table_body  tr.event_date_urgent:first";
            if ($(selector).length > 0) {
                $('html, body').animate({ scrollTop: $(selector).offset().top - 100 }, 300);
            }
        }, 500);
    }
}

function orderBy(array, field, sort) {
    var sortedArray = array.sort(function (first, second) {
        var order_sort = sort[0] === "asc";
        if (first[field[0]] > second[field[0]]) {
            if (order_sort) {
                return 1;
            }
            return -1;
        }
        if (order_sort) {
            return -1;
        }
        return 1;
    });
    return sortedArray;
}

function setLocaleMoment(obj) {
    var lang = window.CalendarValues.currentLangTwoDigit;
    moment.updateLocale(lang, {
        months: obj.months,
        monthsShort: obj.monthsShorts,
        weekdays: obj.weekdays,
        weekdaysShort: obj.weekdaysShorts,
        weekdayMin: obj.weekdaysMins
    })
}
function setLocaleDatePicker(obj) {
    var lang = window.CalendarValues.currentLangTwoDigit;
    $.fn.datepicker.languages[lang] = {
        days: obj.weekdays,
        daysShort: obj.weekdaysShorts,
        daysMin: obj.weekdaysMins,
        months: obj.months,
        monthsShort: obj.monthsShorts
    }

    $('[data-toggle="datepicker"]').datepicker({
        language: lang
    });

}
function updateCalendarDatesEvery500() {

    setInterval(function () {
        g_nearestTime = nearestTimeForFuture();
        $('#eventDate_table_body > tr').each(function (index) {
            var time = $(this).attr("time");
            if (time) {
                var currentLeftTime = calcTimeLeft(time);
                const diffTime = calcDiffTime(time);
                var second = $(this).children().eq(2);
                this.classList.remove('event_date_urgent');
                if (currentLeftTime !== "passed") {
                    second.html(currentLeftTime);
                    if (diffTime === g_nearestTime && g_nearestTime !== 'passed') {
                        this.classList.add('event_date_urgent');
                    }
                } else {
                    second.html('--');
                }
            }
        });
        $('#mobile_eventDate_table_body > tr').each(function (index) {
            var time = $(this).attr("time");
            if (time) {
                const diffTime = calcDiffTime(time);
                if (diffTime !== "passed") {
                    if (diffTime === g_nearestTime && g_nearestTime !== 'passed') {
                        this.classList.add('event_date_urgent');
                    }
                }
            }
        });
    }, 1000);
}

function updateCalendarDatesEvery2000OnHomePage() {

    setInterval(function () {
        g_nearestTime = nearestTimeForFuture();
        $('#eventDate_table_body > tr').each(function (index) {
            var time = $(this).attr("time");
            if (time) {
                const diffTime = calcDiffTime(time);
                this.classList.remove('event_date_urgent');
                if (diffTime !== "passed") {
                    if (diffTime === g_nearestTime && g_nearestTime !== 'passed') {
                        this.classList.add('event_date_urgent');
                    }
                }
            }
        });
        $('#mobile_eventDate_table_body > tr').each(function (index) {
            var time = $(this).attr("time");
            if (time) {
                const diffTime = calcDiffTime(time);
                if (diffTime !== "passed") {
                    if (diffTime === g_nearestTime && g_nearestTime !== 'passed') {
                        this.classList.add('event_date_urgent');
                    }
                }
            }
        });
    }, 2000);
}

function updateCurrentTimeTH() {
    setInterval(function () {
        SetCurrentTHTime();
    }, 1000);
}

function onClickNotificationSoundToggle() {
    turnOffNotificationSound = !turnOffNotificationSound;
    saveTurnOffNotificationSoundOnCookie();
    updateSoundToggleIcon();

    if (isLoggedIn) {
        saveNotificationSoundPreference();
    }
}

function saveNotificationSoundPreference() {
    if (!isLoggedIn) {
        return;
    }

    $.ajax({
        type: 'POST',
        url: window.CalendarValues.saveNotificationSoundUrl,
        data: {
            turnOffNotificationSound: turnOffNotificationSound
        }
    });
}

function updateSoundToggleIcon() {
    var icon = document.getElementById('ec-sound-toggle-icon');
    if (!icon) {
        return;
    }

    if (turnOffNotificationSound) {
        icon.src = '/content/dist/images/icons/sound-off.svg';
    } else {
        icon.src = '/content/dist/images/icons/sound-on.svg';
    }
}

function playNotificationSound() {
    if (turnOffNotificationSound) {
        return;
    }

    var notification_audio = new Audio('/content/dist/audio/notification.mp3');
    notification_audio.loop = false;
    notification_audio.play();
}

function drawLineChartForTE(historical) {
    var actualDatas = historical.map(function (data, index) {
        var actualVal = data.ActualVal != null ? Math.round(data.ActualVal * 10000) / 10000 : data.Actual;
        if (actualVal == undefined || actualVal == '') actualVal = null;
        return { x: new Date(data.Date * 1000).getTime(), y: actualVal };
    });

    var consensusDatas = historical.map(function (data, index) {
        var forecastVal = data.ForecastVal != null ? data.ForecastVal : data.TEForecastVal;
        var forecastValStr = (data.Forecast != null || data.Forecast != undefined) ? data.Forecast : data.TEForecast;
        var forecast = forecastVal != null ? Math.round(forecastVal * 10000) / 10000 : forecastValStr;
        if (forecast == undefined || forecast == '') forecast = null;
        return { x: new Date(data.Date * 1000).getTime(), y: forecast };
    });

    var lang = window.CalendarValues.currentLangTwoDigit;
    var localeInfo = lang;
    if (lang === 'zh') {
        localeInfo = 'zh-cn';
    }
    var options = {
        chart: {
            id: 'event_historical_chart',
            type: 'line',
            height: '400px',
            defaultLocale: localeInfo,
            toolbar: {
                show: true
            },
            redrawOnParentResize: true
        },
        series: [{
            name: window.CalendarValues.actualString,
            data: actualDatas
        },
        {
            name: window.CalendarValues.forecastString,
            data: consensusDatas
        }],
        yaxis: {
            opposite: false,
            axisBorder: {
                show: true,
                color: '#CED3D9',
                width: 1,
                height: '100%',
                offsetX: -3,
                offsetY: 0
            },
            labels: {
                show: true,
                offsetX: -10,
                offsetY: 0
            }
        },
        xaxis: {
            axisBorder: {
                show: true
            },
            type: 'datetime',
            tickAmount: 6
        },
        colors: ['#FD7558', '#00CC66'],
        tooltip: {
            x: {
                formatter: function (value, timestamp, opts) {
                    return new Date(value).toLocaleString(lang, { timeZone: currentTimeZone });
                }
            },
            shared: true,
            intersect: false
        },
        fill: {

        },
        stroke: {
            show: true,
            curve: 'straight',
            width: 2,
            dashArray: [0, 8, 5],
        },
        grid: {
            show: true,
            borderColor: '#CED3D9',
            strokeDashArray: 0,
            position: 'front',
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
            row: {
                colors: undefined,
                opacity: 0.5
            },
            column: {
                colors: undefined,
                opacity: 0.5
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
        }
    }
    var url = "https://cdn.jsdelivr.net/npm/apexcharts/dist/locales/" + localeInfo + '.json';
    $.ajax({
        type: 'GET',
        url: url,
        complete: function (data) {
            if (data.responseJSON) {
                options['chart']['locales'] = [data.responseJSON];
            }
            chart = new ApexCharts(document.querySelector('#event_historical_chart'), options);
            chart.render();
        }
    });
}
function setUserFiltersFromData(data) {
    const impactFilters = data.impactFilters || [];
    if (impactFilters.length > 0)
        selectedIMPACTS = impactFilters;
    tmpSelectedIMPACTS = [].concat(selectedIMPACTS);

    const countryFilters = data.countryFilters || [];
    const currencyFilters = data.currencyFilters || [];

    if (countryFilters.length > 0)
        selectedCountries = [].concat(countryFilters);

    tmpSelectedCountries = [].concat(selectedCountries);

    if (currencyFilters.length > 0)
        selectedCurrencies = [].concat(currencyFilters);
    tmpSelectedCurrencies = [].concat(selectedCurrencies);

    if (data.userNotificationSetting) {
        isLiveNotification = data.userNotificationSetting.Live ? true : false;
        isSmsNotification = data.userNotificationSetting.SMS ? true : false;
        isEmailNotification = data.userNotificationSetting.Email ? true : false;

        isNotificationBefore = data.userNotificationSetting.BeforeStatus;
        notificationBeforeMin = data.userNotificationSetting.beforeMin;
    }

    if (typeof data.turnOffNotificationSound === 'boolean') {
        turnOffNotificationSound = data.turnOffNotificationSound;
        saveTurnOffNotificationSoundOnCookie();
    }

    updateSoundToggleIcon();
}

function getEventDateById(eventdateId) {
    var lang = window.CalendarValues.currentLangTwoDigit;
    if (lang !== "") {
        lang = "/" + lang;
    }

    var getEventDateByIdUrl = lang + window.CalendarValues.getEventDateByIdURL + eventdateId;
    $.ajax({
        type: 'GET',
        url: getEventDateByIdUrl,
        success: function (data) {
            setTEEventDetailInfo(data);
        },
        error: function (err) {
            //showLoading(false);
        }
    });
}

function setTEEventDetailInfo(data) {
    var histoical = data.historical;
    var description = data.description;
    var desciptionText = '';
    if (description !== null) {
        descriptionText = description['Definion'] || '';
    }
    // $('#event_description_span').text(desciptionText);
    $('#event_title').html(data.detail.TEEvent.OEvent);
    $('#event_historical_chart').html('');
    $('#eventDateIdLoading').hide();
    $('#eventDateContent').show();
    $('.ec-modal-detail').attr('onclick', 'OpenEvetDateRowDetailPage(\'' + data.detail.TEEvent.OCountry + '\', \'' + data.detail.TEEvent.OCategory + '\')')
    drawLineChartForTE(histoical);
}
function saveFiltersAndLive(showSuccessMessage, shouldRefreshTable) {
    if (showSuccessMessage === undefined) {
        showSuccessMessage = true;
    }
    if (shouldRefreshTable === undefined) {
        shouldRefreshTable = true;
    }

    if (isLoggedIn) {
        showLoading(true);
        $.ajax({
            type: 'POST',
            url: window.CalendarValues.saveFiltersAndLiveUrl,
            data: {
                impacts: JSON.stringify(selectedIMPACTS),
                countries: JSON.stringify(selectedCountries),
                currencies: JSON.stringify(selectedCurrencies),
                beforeMin: 10,
                isLiveNotification: isLiveNotification,
                isSMSNotification: isSmsNotification,
                isEmailNotification: isEmailNotification,
                isBeforeStatus: isNotificationBefore,
                turnOffNotificationSound: turnOffNotificationSound
            },
            success: function (data) {
                showLoading(false)
                if (showSuccessMessage) {
                    toastr.success(window.CalendarValues.calendarFiltersSavedString);
                }
                if (shouldRefreshTable) {
                    generateEventDateTableBody(eventDateDatas, false);
                }
            },
            error: function (err) {
                showLoading(false);
                toastr.error(window.CalendarValues.calendarFiltersFailedToSaveString);
            }
        })
    }
}

function onClickTableRow(id, eid) {
    var popoverElm = document.querySelector('.popover');
    if (popoverElm && isMobile) {
        return;
    }

    
    if (frontendType == 'Article' || frontendType == 'Home') {
        openDetailedEventDateModal(eid);
    } else {
        $('#eventDateDetail').modal();
        $('#eventDateIdLoading').show();
        $('#eventDateContent').hide();
        $('#event_title').html('');
        $('#event_description_span').html('');
        $('#event_historical_chart').html('');
        getEventDateById(id);
    }
}

function openDetailedEventDateModal(eid) {
    $('#eventDateContent').hide();
    $('#eventDateIdLoading').show();
    $('#event_title').html('');
    $('#event_description_span').html('');
    $('#event_historical_chart').html('');

    $('#eventDateDetail').modal();

    var langSlug = "";
    if (window.CURRENT_LANG != "en")
        langSlug = "/" + window.CURRENT_LANG;

    
    $.ajax({
        url: langSlug + '/apis/calendar/te/event-detail-partial/' + eid,
        type: 'POST',
        success: function (view) {
            $("#eventDateContent").html(view);
            $("#eventDateContent").show();
            InitEventDetailView('#eventDateContent');
        },
        complete: function () {
            $('#eventDateIdLoading').hide();
        },
        error: function () {
            
            toastr.error("There wan an error! Please try again later");
        }
    })
}
function InitEventDetailView(container) {
    window.Tabs.InitTabs(container + ' #calendar-detail-tabs',
        {
            localStoreName: 'calendar-detail-tabs',
            ignoreHash: true,
            setTabLink: false,
            manipulateUrl: false,
            postRenderCallback: function () {
                if (window.Tabs.GetCurrentTab("#calendar-detail-tabs") == 'tab-chart') {
                    ApexCharts.exec('event_historical_chart', 'resize');
                }
            },
            defaultTab: 'tab-info'
        });

    drawLineChartForTE(window.eventDetailHistoricalDates);

    initImpactTooltip();

    $('[data-toggle="popover-hover"]').popover({
        trigger: 'hover',
        template: '<div class="popover ecal-popover" role="tooltip">' +
            '<div class="arrow"></div>' +
            '<h3 class="popover-header"></h3>' +
            '<div class="popover-body"></div>' +
            '</div>'
    });

    $('[data-action="big-surprise-tooltip-green"]').tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.bigSurpriseUpPopoverText
    });
    $('[data-action="big-surprise-tooltip-red"]').tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.bigSurpriseDownPopoverText
    });
    $('[data-action="surprise-tooltip"]').tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.surpriseLabelPopoverText
    });
    $('[data-action="actual-tooltip"]').tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.actualLabelPopoverText
    });
    $('[data-action="forecast-tooltip"]').tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.forecastLabelPopoverText
    });
    $('[data-action="previous-revision-tooltip"]').tooltip('dispose').tooltip({
        trigger: 'hover',
        html: true,
        title: window.CalendarValues.previousLabelPopoverText
    });

    InitializeScrollTable('table.event-detail-history-table');

    initBigSurpriseTooltip();

    initEventDetailPageTime();
}

function onChangeCustomStartDate() {
    fromDate = $('#calendarStartDate').val();
}
function onChangeCustomEndDate() {
    toDate = $('#calendarEndDate').val();
}

function onClickCustomFilter() {
    getEventDates(fromDate, toDate, false, false, null);
}
function hasSomeParentTheClass(element, classname) {
    if (element.className && element.className.split(' ').indexOf(classname) >= 0) return true;
    return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
}
function hasSomeParentTheId(element, id) {
    if (element.id && element.id === id) return true;
    return element.parentNode && hasSomeParentTheId(element.parentNode, id);
}

function closePopover() {
    $('[data-toggle="popover"]').popover('hide');
}
window.onclick = function (e) {
    //did not click a popover toggle, or icon in popover toggle, or popover
    if ($(e.target).data('toggle') !== 'popover'
        && $(e.target).parents('[data-toggle="popover"]').length === 0
        && $(e.target).parents('.popover').length === 0) {
        closePopover();
    }
};

//cookie section
function setCookie(name, value) {
    localStorage.setItem('ec-calendar:' + name, value);
}

function getCookie(name) {
    if (localStorage.getItem('ec-calendar:' + name) !== null) {
        return localStorage.getItem('ec-calendar:' + name);
    } else {
        var re = new RegExp(name + "=([^;]+)");
        var value = re.exec(document.cookie);
        return (value != null) ? unescape(value[1]) : null;
    }
}

function saveCurrentTimeConf() {
    setCookie('currentTimeZone', currentTimeZone);
    setCookie('currentTimeFormat', currentTimeFormat);
}

function saveFilterImpacts() {
    var impact = JSON.stringify(selectedIMPACTS);
    setCookie('filterImpacts', impact);
}

function saveFilterCountries() {
    setCookie('filterCountries', JSON.stringify(selectedCountries));
}

function saveFilterCurrencies() {
    setCookie('filterCurrencies', JSON.stringify(selectedCurrencies));
}

function saveTurnOffNotificationSoundOnCookie() {
    setCookie('turnOffNotificationSound', turnOffNotificationSound);
}

function loadTurnOffNotificationSoundFromCookie() {
    var turnOffNotificationSoundFromCookie = getCookie('turnOffNotificationSound');
    if (turnOffNotificationSoundFromCookie !== null) {
        turnOffNotificationSound = (turnOffNotificationSoundFromCookie === 'true');
    }
}

function saveCalendarDayType() {

    setCookie('calendar_' + frontendType + '_dayType', currentDayType);
}

function loadCalendarDayType() {

    var dayType = getCookie('calendar_' + frontendType + '_dayType');
    if (dayType !== null && dayType !== '' && dayType !== 'custom') {
        currentDayType = dayType;
    } else {
        if (frontendType === 'Home')
            currentDayType = 'today';
        else currentDayType = 'this_week'
    }
}
function saveFiltersOnCookie() {
    saveFilterImpacts();
    saveFilterCountries();
    saveFilterCurrencies();
    saveTurnOffNotificationSoundOnCookie();
}

function getFiltersFromCookie() {
    var filterImpacts = getCookie('filterImpacts');
    var filterCountries = getCookie('filterCountries');
    var filterCurrencies = getCookie('filterCurrencies');
    var savedTurnOffNotificationSound = getCookie('turnOffNotificationSound');

    if (filterImpacts !== null) {
        selectedIMPACTS = JSON.parse(filterImpacts);
        tmpSelectedIMPACTS = [].concat(selectedIMPACTS);
    } 
    if (filterCountries !== null) {
        selectedCountries = JSON.parse(filterCountries);
        tmpSelectedCountries = [].concat(selectedCountries);
    }
    if (filterCurrencies !== null) {
        selectedCurrencies = JSON.parse(filterCurrencies);
        tmpSelectedCurrencies = [].concat(selectedCurrencies);
    }

    if (savedTurnOffNotificationSound !== null) {
        turnOffNotificationSound = (savedTurnOffNotificationSound === 'true');
    }

    updateSoundToggleIcon();
}

if (window.cookieStateValues !== undefined && window.cookieStateValues.logged !== undefined && window.cookieStateValues.logged === "1") {
    isLoggedIn = true;
}

function OpenCalendarPopup(e) {
    if (frontendType === 'WidgetMaker' || frontendType === 'ArticleMaker') {
        return false;
    }
    var link = e.href;
    var width = 1000;
    var height = screen.height;
    var left = (screen.width / 2) - (width / 2);
    var top = (screen.height / 2) - (height / 2);

    window.open(link, "", "width=" + width + ", height=" + height + ", left=" + left + ", top=" + top);
    return false;
}
//// Embedded Section
function OnCopyCalendarEmbedScript() {
    var calendarPreviewEl = document.getElementById('calendar-embed-script-preview-output');
    if (calendarPreviewEl) {
        var scriptVal = calendarPreviewEl.value;
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = scriptVal;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);

        var notificationEl = document.getElementById('calendar-embed-copy-notification-panel');
        if (notificationEl) {
            notificationEl.style.display = 'block';
            setTimeout(function () {
                notificationEl.style.display = 'none';
            }, 3000);
        }
    }

    GenerateCalendarRemoteScript();
}

function GenerateCalendarRemoteScript() {

    CalendarWidgetConfig = new Object();

    var language = document.getElementById('calendar-widget-language-select').value;
    if (language != "browser") {
        CalendarWidgetConfig.Lang = language;
    }

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;


    CalendarWidgetConfig.Url = hostUrl;
    CalendarWidgetConfig.SubPath = "economic-calendar";

    var defaultTimeFrame = document.getElementById('calendar-widget-default-timeframe-select').value;
    CalendarWidgetConfig.DefaultTimeFrame = defaultTimeFrame;
    CalendarWidgetConfig.IsShowEmbedButton = $('#show-embed-button').prop('checked');
    CalendarWidgetConfig.DefaultTheme = window.CalendarDefaultStyle;

    if (defaultFilterCountries && defaultFilterCountries.length > 0) {
        CalendarWidgetConfig.DefaultCountries = defaultFilterCountries.join(',');
    }

    if (defaultFilterImpacts && defaultFilterImpacts.length > 0) {
        CalendarWidgetConfig.DefaultImpacts = defaultFilterImpacts.join(',');
    }


    document.getElementById('calendar-embed-script-preview-output').value = GenerateCalendarWidgetScript(CalendarWidgetConfig);

}

function GenerateCalendarPreviewLink(WidgetConfig) {
    if (WidgetConfig.Url == undefined) {

        WidgetConfig.Url = "https://www.cashbackforex.com";
    }

    // assign url

    var frameSrc = WidgetConfig.Url;

    if (WidgetConfig.Lang != undefined) {
        if (WidgetConfig.Lang == 'page')
            WidgetConfig.Lang = window.CURRENT_LANG;

        frameSrc += '/' + WidgetConfig.Lang;
    }

    frameSrc += '/widgets/' + WidgetConfig.SubPath;

    if (WidgetConfig.ContainerId != undefined) {
        frameSrc += "?ContainerId=" + WidgetConfig.ContainerId;
    }

    return frameSrc;
}

function GenerateCalendarPopoutLink() {
    var lang = window.CalendarValues.currentLangTwoDigit;
    if (lang === 'en') {
        lang = '/';
    } else {
        lang = '/' + lang + '/';
    }
    var url = lang + 'tools/economic-calendar#popout';

    return url;
}


function GenerateCalendarWidgetScript(WidgetConfig) {
    var containerId = WidgetConfig.SubPath + "-" + Math.ceil(Math.random() * 1000000);

    var previewScript = "<div id=\"" + containerId + "\">";

    previewScript += "<script type=\"text/javascript\" src=\"" + WidgetConfig.Url + RemoteCalendarScriptJsLink + "\"><\/script>";

    previewScript += "<script type=\"text/javascript\"> RemoteCalendar({";
    if (WidgetConfig.Lang) {
        previewScript += "\"Lang\":\"" + WidgetConfig.Lang + "\",";
    }
    if (WidgetConfig.DefaultTimeFrame) {
        previewScript += "\"DefaultTime\": \"" + WidgetConfig.DefaultTimeFrame + "\",";
    }
    if (WidgetConfig.DefaultTheme) {
        previewScript += "\"DefaultTheme\": \"" + WidgetConfig.DefaultTheme + "\",";
    }
    previewScript += "\"Url\":\"" + WidgetConfig.Url + "\", ";
    previewScript += "\"SubPath\":\"" + WidgetConfig.SubPath + "\",";
    if (WidgetConfig.IsShowEmbedButton !== undefined) {
        previewScript += "\"IsShowEmbedButton\":" + WidgetConfig.IsShowEmbedButton + ",";
    }
    if (WidgetConfig.DefaultCountries !== undefined) {
        previewScript += "\"DefaultCountries\":\"" + WidgetConfig.DefaultCountries + "\",";
    }
    if (WidgetConfig.DefaultImpacts !== undefined) {
        previewScript += "\"DefaultImpacts\":\"" + WidgetConfig.DefaultImpacts + "\",";
    }
    previewScript += "\"ContainerId\":\"" + containerId + "\"";
    previewScript += "});<\/script><\/div>";

    return previewScript;
}

function OpenCalendarEmbedOverlay() {
    var currentLocation = window.location.pathname;
    if (window.CalendarValues.calendarModel.Type === 'Article') {
        window.location.href = currentLocation + '-widget';
    } else if (window.CalendarValues.calendarModel.Type === 'Widget') {
        var url = currentLocation + '-widget';
        window.open(url, '_blank').focus();
    } else if (window.CalendarValues.calendarModel.Type === 'ArticleMaker' || window.CalendarValues.calendarModel.Type === 'WidgetMaker') {
        /*var width = 800;
        windo.open(currentLocation, "", "width=" + width);*/
    } else if (window.CalendarValues.calendarModel.Type === 'Homepage') {
        var url = '/tools/economic-calendar';
        if (window.CalendarValues.currentPageLangTwoDigit !== '') {
            url = '/' + window.CalendarValues.currentPageLangTwoDigit + url;
        }
        window.open(url, '_blank').focus();
    }
}

function CloseCalendarEmbedOverlay() {
    $("#calendar-embed-script-overlay").css("display", "none");
    sendStickyShowHide(true);
}

function UpdateCanonicalLink() {
    var link = GenerateArticleCalendarLink();

    if (frontendType === 'ArticleMaker' || frontendType === 'WidgetMaker') {
        link = link + '-widget';
    } else if (frontendType == "Widget") {
        link = "https://fxverify.com" + link;
    }
    $("link[rel='canonical']").attr('href', link);
}

function GenerateArticleCalendarLink() {
    var link = '/tools/economic-calendar';
    var lang = window.CalendarValues.currentLangTwoDigit;
    if (lang !== 'en' && lang !== '') {
        link = '/' + lang + link;
    }
    return link;
}

function GenerateRemoteStickyHeader(id) {
    var sourceElement = document.getElementById(id);
    var sourceThs = sourceElement.getElementsByTagName('th');
    var ret = '';
    for (var i = 0; i < sourceThs.length; i++) {
        var sourceTh = sourceThs[i];
        var th = GenerateClonedElement(sourceTh, true, 0, ['div'], undefined, ['onclick', 'id', 'class']);
        ret += th.outerHTML;
    }
    return [ret, sourceThs.length];
}

function GenerateClonedElement(sourceElement, isChildConvert, step, targetArray, targetTag, acceptAttributes) {
    var tTag = targetTag;
    var tg;
    if (targetArray && Array.isArray(targetArray)) {
        tg = targetArray[step];
    }

    if (targetTag !== undefined && targetTag !== '') {
        tTag = targetTag;
    } else if (tg !== undefined) {
        tTag = tg;
    } else {
        tTag = sourceElement.tagName;
    }
    var ttTag = document.createElement(tTag);
    var computedStyle = window.getComputedStyle(sourceElement);
    Array.from(computedStyle).forEach(function (key) {
        var value = computedStyle.getPropertyValue(key);
        var priority = computedStyle.getPropertyPriority(key);
        /*if (key === 'display' && value === 'table') {
            value = 'block';
        }*/
        return ttTag.style.setProperty(key, value, priority);
    });

    for (var i = 0, atts = sourceElement.attributes, n = atts.length; i < n; i++) {
        var isAcceptable = false;
        if (acceptAttributes && Array.isArray(acceptAttributes)) {
            for (var j = 0; j < acceptAttributes.length; j++) {
                if (acceptAttributes[j] === atts[i].nodeName) {
                    isAcceptable = true;
                }
            }
        }
        if (isAcceptable) {
            ttTag.setAttribute(atts[i].nodeName, atts[i].nodeValue);
        }
    }
    if (sourceElement.classList.contains('event_date_col')) {
        ttTag.innerHTML = sourceElement.innerHTML;
    } else {
        if (sourceElement.children.length > 0) {
            if (isChildConvert) {
                for (var i = 0; i < sourceElement.children.length; i++) {
                    var childTag = sourceElement.children[i];
                    var clonedChildTag = GenerateClonedElement(childTag, isChildConvert, step + 1, targetArray, targetTag, acceptAttributes);
                    ttTag.append(clonedChildTag);
                }
                // TODO (with childNodes)
            }

        } else {
            ttTag.innerHTML = sourceElement.innerHTML;
        }
    }

    return ttTag;
}

function postMessageToRemoteWidget(data) {
    window.parent.postMessage(data, '*');
}

function sendCreateStickyHeader(id) {
    if (frontendType === 'Widget') {
        var ret = GenerateRemoteStickyHeader(id);
        postMessageToRemoteWidget({
            'type': 'createdStickyHeader',
            'data': {
                'element': ret[0],
                'containerId': calendarWidgetId,
                'originalId': id,
                'length': ret[1]
            }

        });
    }

}

function sendCreateStickyContent(id, isDesktop) {
    if (frontendType === 'Widget') {
        var contentElement = GenerateRemoteStickyContent(id, isDesktop === 'desktop');
        var top = GetTableHeaderHeight(id);
        postMessageToRemoteWidget({
            'type': 'createdStickyContent',
            'data': {
                'element': contentElement,
                'containerId': calendarWidgetId,
                'originalId': id,
                'top': top
            }

        });
    }
}
function GetTableHeaderHeight(id) {
    var element = document.getElementById(id);
    var theads = element.parentElement.getElementsByTagName('thead');
    if (theads.length > 0) {
        var thead = theads[0];
        var height = thead.getBoundingClientRect().height;
        return height;
    }
    return 0;
}
function GenerateRemoteStickyContent(id, isdesktop) {
    var element = document.getElementById(id);
    if (isdesktop) {
        var els = element.getElementsByTagName('tr');
        var ret = '';
        for (var i = 0; i < els.length; i++) {
            var sourceTr = els[i];
            if (sourceTr.classList.contains('loadingTr')) {
                continue;
            }
            var sourceTds = sourceTr.getElementsByTagName('td');
            var sourceTd = sourceTds[0];
            var targetTd = GenerateClonedElement(sourceTd, true, 0, ['div'], undefined, ['class']);
            ret += targetTd.outerHTML;
        }
        return ret;
    } else {
        var els = element.getElementsByTagName('tr');
        var ret = '';
        for (var i = 0; i < els.length; i++) {
            var sourceTr = els[i];
            if (sourceTr.classList.contains('sticky-container')) {
                var targetTr = GenerateClonedElement(sourceTr.children[0], true, 0, ['div', 'div'], undefined, ['class']);
                ret += targetTr.outerHTML;
            } else {
                var targetTr = GenerateClonedElement(sourceTr, false, 0, ['div'], undefined, []);
                targetTr.innerHTML = '';
                targetTr.style.background = 'transparent';
                targetTr.style.pointerEvents = 'none';
                ret += targetTr.outerHTML;
            }
        }
        return ret;
    }

}
function sendMessageSortChanged(id) {
    var sourceElement = document.getElementById(id);
    var ret = '';
    var children = sourceElement.children;
    if (children.length > 0) {
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            var cChild = GenerateClonedElement(child, true, 0, [], undefined, ['onclick', 'id']);
            ret += cChild.outerHTML;
        }
    } else {
        ret = sourceElement.innerHTML;
    }

    postMessageToRemoteWidget({
        'type': 'replaceElement',
        'data': {
            'element': ret,
            'id': id,
            'containerId': calendarWidgetId
        }
    })
}

function sendPopoutButton() {
    if (frontendType === 'Widget') {

        

        var id = 'popout-economic-calendar-id';
        var contentElement = GeneratePopoutButton(id);
        var styles = window.getComputedStyle(document.querySelector('#popout-economic-calendar-id img'));

        postMessageToRemoteWidget({
            'type': 'createdPopoutButton',
            'data': {
                'element': contentElement,
                'containerId': calendarWidgetId,
                'originalId': id,
                'styles': {
                    'filter': styles['filter']
                }
            }

        });
    }
}

function sendStickyShowHide(isShow) {
    if (frontendType === 'Widget') {
        postMessageToRemoteWidget({
            'type': 'showStickyShowHide',
            'data': {
                'show': isShow,
                'containerId': calendarWidgetId,
            }
        });
    }
}
function GeneratePopoutButton(id) {
    var el = document.getElementById(id);
    var cloned = GenerateClonedElement(el, true, 0, [], undefined, ['id', 'onclick', 'style', 'src', 'target', 'alt']);
    return cloned.outerHTML;
}

function getAbsoluteHeight(el) {
    // Get the DOM Node if you pass in a string
    el = (typeof el === 'string') ? document.querySelector(el) : el;

    var styles = window.getComputedStyle(el);
    var margin = parseFloat(styles['marginTop']) +
        parseFloat(styles['marginBottom']);

    return Math.ceil(el.offsetHeight + margin);
}

function AddHrefToCalendarElement(embedContent) {
    var embedSlug = embedContent.querySelector('#widget-slug');
    var slug = '';
    if (embedSlug) {
        slug = embedSlug.getAttribute('value');
    }
    var embedBtn = embedContent.querySelector('.embed-button');
    if (embedBtn) {
        var href = '';
        if (window.CalcWidgetType === 'ArticleMaker' || window.CalcWidgetType === 'WidgetMaker') {

        } else {
            var en = '';
            if (window.CURRENT_LANG != 'en') {
                en = window.CURRENT_LANG + '/';
            }
            var url = window.location.protocol + "//" + window.location.hostname;
            if (window.location.port !== "")
                url += ":" + window.location.port;
            url += '/' + en + 'tools/' + slug + '-widget';
            embedBtn.setAttribute('href', url);
        }
    }
}
function AddHrefToEmbedButtonToCalendar() {
    var embedWidgetContents = document.getElementsByClassName('calendar-body');
    for (var i = 0; i < embedWidgetContents.length; i++) {
        AddHrefToCalendarElement(embedWidgetContents[i]);
    }

}

function OnECThemeChanged() {
    if ($(".calendar-body .lc-switch").hasClass("checked")) {
        $(".calendar-body .lc-switch").removeClass("checked");
        
        $(".calendar-body").removeClass("plain");
        $(".calendar-body").addClass("dark");
        setCookie("current-ec-theme", 'dark');
    }
    else {
        $(".calendar-body .lc-switch").addClass("checked");

        $(".calendar-body").removeClass("dark");
        $(".calendar-body").addClass("plain");

        setCookie("current-ec-theme", 'plain');
    }
}
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _CalendarWidgetStyle = _interopRequireDefault(require("../../includes/CalendarWidgetStyle.js"));
var _Tabs = _interopRequireDefault(require("../../includes/Tabs.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
$(function () {
  window.Tabs = new _Tabs["default"]();
  window.InitializeCalendarWidget = function () {
    window.CalendarWidgetStyle = new _CalendarWidgetStyle["default"]();
    InitializeCalendarWidgetMaker();
  };
  window.InitializeCalendarWidget();
});

},{"../../includes/CalendarWidgetStyle.js":2,"../../includes/Tabs.js":3}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CalendarWidgetStyle = /*#__PURE__*/function () {
  function CalendarWidgetStyle() {
    _classCallCheck(this, CalendarWidgetStyle);
  }
  return _createClass(CalendarWidgetStyle, [{
    key: "SetWidgetStyleCookie",
    value: function SetWidgetStyleCookie(styleType, style) {
      window.localStorage.setItem(styleType, btoa(style));
    }
  }, {
    key: "GetDefaultTheme",
    value: function GetDefaultTheme() {
      if (window.localStorage.getItem("CalendarDefaultTheme")) {
        return atob(window.localStorage.getItem("CalendarDefaultTheme"));
      }
      return "";
    }
  }, {
    key: "SetDefaultTheme",
    value: function SetDefaultTheme(val) {
      this.SetWidgetStyleCookie('CalendarDefaultTheme', val);
    }
  }, {
    key: "GetDefaultLang",
    value: function GetDefaultLang() {
      if (window.localStorage.getItem("CalendarDefaultLang")) {
        return atob(window.localStorage.getItem("CalendarDefaultLang"));
      }
      return "";
    }
  }, {
    key: "SetDefaultLang",
    value: function SetDefaultLang(val) {
      this.SetWidgetStyleCookie('CalendarDefaultLang', val);
    }
  }, {
    key: "GetDefaultTime",
    value: function GetDefaultTime() {
      if (window.localStorage.getItem("CalendarDefaultTime")) {
        return atob(window.localStorage.getItem("CalendarDefaultTime"));
      }
      return "";
    }
  }, {
    key: "SetDefaultTime",
    value: function SetDefaultTime(val) {
      this.SetWidgetStyleCookie('CalendarDefaultTime', val);
    }
  }, {
    key: "GetShowEmbed",
    value: function GetShowEmbed() {
      if (window.localStorage.getItem("CalendarIsEmbed")) {
        return atob(window.localStorage.getItem("CalendarIsEmbed"));
      }
      return "";
    }
  }, {
    key: "SetShowEmbed",
    value: function SetShowEmbed(val) {
      this.SetWidgetStyleCookie('CalendarIsEmbed', val);
    }
  }]);
}();
var _default = exports["default"] = CalendarWidgetStyle;

},{}],3:[function(require,module,exports){
'use strict';

/*
 * Config Options:
 *  localStoreName - specify local storage name to preserve state when user navigates from page
 *  postRenderCallback - Callback to call when content of ajax tab has been rendered to page
 *  compactOnResize - specify if tabs are to collapse to select list drop down on small screen
 *  preLoadCallback - callback executed before Ajax page is loaded, or after tab is clicked on non Ajax loading tabs
 *  haltInitLoad - prevent Ajax load on first initialisation of tabs
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _templateObject, _templateObject2;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tabs = /*#__PURE__*/function () {
  function Tabs() {
    var _this = this;
    _classCallCheck(this, Tabs);
    var shortCuts;
    this.hash = document.location.hash;
    if (this.hash && this.hash.includes("tab-") && $(this.hash).length) {
      this.SwitchTab(this.hash.replace("#", ""));
    } else if ($('#active-tab').length) {
      var activeTab = $('#active-tab').val();
      activeTab = "tab-" + activeTab.substr(0, 3);
      this.SwitchTab(activeTab);
    } else {
      this.shortCuts = localStorage.getItem('_tabShortCuts');
      if (!(this.shortCuts == undefined || this.shortCuts === "")) {
        // inflate string to data object
        this.shortCuts = JSON.parse(this.shortCuts);
        var localShortCuts = this.shortCuts;
        if (_typeof(this.shortCuts) == 'object') {
          // valid shortcuts object found in local storage, 
          // check for URL parameters looking to select tabs on page
          var vars = this.GetParameters();
          var BreakException = {};
          if (vars.tab != undefined) {
            vars.tab.forEach(function (value) {
              for (var storedTabsId in localShortCuts) {
                if (Array.isArray(_this.shortCuts[storedTabsId])) {
                  try {
                    localShortCuts[storedTabsId].forEach(function (vle) {
                      if (vle === "tab-" + value) {
                        // set the local storage for this tab
                        localStorage.setItem(storedTabsId + "-current-tab", "tab-" + value);
                        // exclude this storedTabs Id from any subsequent search of query vars
                        localShortCuts[storedTabsId] = undefined;
                        // throw exception to break the loop
                        throw BreakException;
                      }
                    });
                  } catch (e) {
                    if (e !== BreakException) throw e;
                  }
                } else {
                  if (_this.shortCuts[storedTabsId] === undefined) {}
                }
              }
            });
          }
          ;
        }
      }
    }
  }
  return _createClass(Tabs, [{
    key: "WhatHash",
    value: function WhatHash() {
      alert("from what hash " + this.hash);
    }
  }, {
    key: "InitTabs",
    value: function InitTabs(frame, config) {
      if ($(frame).hasClass('tab-frame')) {
        return;
      }
      var localStoreName = null;
      var locallyStoredCurrentTab = null;
      var currentTab = null;
      var currentTabId = null;
      var manipulateUrl = true;
      if (config != undefined) {
        if (config.manipulateUrl == undefined) {
          config.manipulateUrl = manipulateUrl;
        }
        localStoreName = config.localStoreName;
        $(frame).data('tab-config', config);
      }
      if (config && config.ignoreHash === true) {
        this.hash = '';
      }
      $(frame).addClass('tab-frame');
      $(frame + " .frn-tab:not(.no-tab) > a").each(function () {
        if (!$(this).data('click-bound')) {
          $(this).data('click-bound', true).on('click', function (e) {
            e.preventDefault();
            window.Tabs.LoadTab(this);
          });
        }
      });
      if (config && config.compactOnResize !== undefined && config.compactOnResize !== null && config.compactOnResize === true) {
        $(frame + "-compact").on('change', function (e) {
          window.Tabs.LoadTab(this);
        });
      }
      var mythis = this;
      if (config && config.setTabLink === true) {
        $(frame + " .frn-tab:not(.no-tab) > a").each(function (i, e) {
          var basePath = window.location.pathname;
          var vars = mythis.GetParameters();
          for (var key in vars) {
            if (vars.hasOwnProperty(key)) {
              if (key !== 'tab') {
                if (!basePath.includes('?')) {
                  basePath += "?" + key + "=" + vars[key];
                } else {
                  basePath += "&" + key + "=" + vars[key];
                }
              }
            }
          }
          var tabId = $(e).closest("div.frn-tab").prop('id');
          if (basePath.includes('?')) basePath += '&tab=' + tabId.substr(4);else basePath += '?tab=' + tabId.substr(4);
          $(e).attr('href', basePath);
        });
      }
      if (localStoreName !== null) {
        $(frame).data('tab-cache', localStoreName);
        locallyStoredCurrentTab = localStorage.getItem(localStoreName + "-current-tab");
      }
      $(frame + ' .tab-box').hide();

      // consider defaultTag from config
      var defaultTab = config.defaultTab;

      // if defaultTag is not configured, read from tab cache
      if (!defaultTab) defaultTab = locallyStoredCurrentTab;
      if (defaultTab && $('#' + defaultTab).length > 0 && $('#' + defaultTab).is(':visible')) {
        currentTabId = defaultTab;
        currentTab = $('#' + currentTabId);
      } else {
        // Get First tab
        currentTab = $(frame + " .frn-tab:first");
        currentTabId = currentTab.prop('id');
      }
      if (localStoreName !== null) {
        // local storage should have an object of all tab shortcuts(tab ids)
        // this is used for creating direct links to pages with tabs and having specific tabs opened

        if (this.shortCuts == null || this.shortCuts == undefined || !(_typeof(this.shortCuts) == 'object')) {
          // if the shortcut string could not be converted to object
          // start again with new object
          this.shortCuts = new Object();
        }

        // if we have not already recorded the Ids for current tabs in the 
        // localstorage shortcut object, we do so now
        if (this.shortCuts[localStoreName] === undefined) {
          var shortcutIds = [];
          $(frame + " .frn-tab").each(function (key, value) {
            // add the ID of each tab to an array
            shortcutIds.push($(value).prop('id'));
          });
          // save tabIds in for this tab  in the shortcut object
          this.shortCuts[localStoreName] = shortcutIds;
          // commit to local storage
          localStorage.setItem('_tabShortCuts', JSON.stringify(this.shortCuts));
        }

        // record this tab as the current Tab for localStorage
        // (when page is refreshed it will default to this tab rather than first tab on page)
        localStorage.setItem(localStoreName + "-current-tab", currentTabId);
      }
      if (config.haltInitLoad === true) {
        this.SetTabToLoadedState(currentTab.find("a"));
      } else {
        this.LoadTab(currentTab.find("a"));
      }
    }

    /*
     * Set the state of a tab to loaded, without actually loading any data
     */
  }, {
    key: "SetTabToLoadedState",
    value: function SetTabToLoadedState(e) {
      var tabFrame = $(e).closest("div.tab-frame"); // The outer most surrounding box.
      var menuFrame = $(e).closest("div.frn-tabs"); // Frame that holds the menus
      var tabFrameId = $(tabFrame).prop('id'); // Id of the frame menu
      var tab = $(e).closest("div"); // The tab that was clicked
      var tabConfig = $(tabFrame).data('tab-config'); // Tab config data attached to this instance of tabs
      var id = $(tab).prop('id');
      var cache = tabFrame.data('tabCache');
      var progressBar = $('#' + tabFrameId + '-progress');
      var progressBarExists = progressBar.length > 0;
      if (cache != undefined) {
        localStorage.setItem(cache + "-current-tab", id);
      }
      menuFrame.children().removeClass('frn-tab-active');
      $(e).closest("div.frn-tab").addClass('frn-tab-active');
      if (progressBarExists) {
        progressBar.hide();
      }
      if (tabConfig && tabConfig.manipulateUrl === true) {
        this.ManipulateUrl();
      }
    }
  }, {
    key: "LoadTab",
    value: function LoadTab(e) {
      var _this2 = this;
      var tabFrame = $(e).closest("div.tab-frame"); // The outer most surrounding box.
      var tabConfig = $(tabFrame).data('tab-config'); // Tab config data attached to this instance of tabs
      if (tabConfig === undefined) {
        tabConfig = {};
      }
      var menuFrame = $(e).closest("div.frn-tabs"); // Frame that holds the menus
      var tabFrameId = $(tabFrame).prop('id');
      // Id of the frame menu
      var triggerId;
      var url; // the url for ajax call
      var Post; // any data that needs to be sent to ajax call
      var preLoadCallback; // check to see is there a pre-process callback required for this tab ( to be run before page load )    
      var postProcessorCallback; // check to see is there a post-process callback required for this tab ( to be run after page load )
      var postRenderCallback; // check to see is there a post-render callback required for this tab ( to be run after page load )

      // determine if input was from tab link or select list drop down
      var isLink = true;
      var isSelect = false;
      var linkElement; // the link that contains config into

      if (tabConfig && tabConfig.compactOnResize !== undefined && tabConfig.compactOnResize !== null && tabConfig.compactOnResize && $(e).is("select")) {
        isSelect = true;
        isLink = false;
      }
      if (isLink) {
        var trigger = $(e).closest("div"); // The tab that was clicked
        triggerId = $(trigger).prop('id');
        linkElement = e;
      }
      if (isSelect) {
        triggerId = $('#' + tabFrameId + "-compact option:selected").val();
        linkElement = $('#' + triggerId + " > a");
      }
      url = $(linkElement).data('url');
      Post = $(linkElement).data('post');
      preLoadCallback = $(linkElement).data('preload-callback');
      postProcessorCallback = $(linkElement).data('postprocessor-callback');
      postRenderCallback = $(linkElement).data('post-render-callback');
      var cache = tabFrame.data('tabCache');
      var dynamicData = {};
      var progressBar = $('#' + tabFrameId + '-progress');
      var progressBarExists = progressBar.length > 0;

      // Tab Specific pre load callback. 
      // checks to see if the callback returns a data object, and if so stores it 
      // to send with PostData 
      if (preLoadCallback !== undefined) {
        var data;
        var tabInstancePreCallback = preLoadCallback;
        if (typeof tabInstancePreCallback == "string") {
          data = window[tabInstancePreCallback](linkElement);
        } else {
          data = tabInstancePreCallback(linkElement);
        }
        if (_typeof(data) == "object") {
          dynamicData = data;
        }
      }

      // Generic pre load callback (applies to all tabs)
      if (tabConfig && tabConfig.preLoadCallback !== undefined) {
        var callback = tabConfig.preLoadCallback;
        if (typeof callback == "string") {
          dynamicData = window[callback](linkElement);
        } else {
          dynamicData = callback(linkElement);
        }
      }
      if (cache != undefined) {
        localStorage.setItem(cache + "-current-tab", triggerId);
      }
      menuFrame.children().removeClass('frn-tab-active');
      $(e).closest("div.frn-tab").addClass('frn-tab-active');
      if (tabConfig && tabConfig.compactOnResize !== undefined && tabConfig.compactOnResize !== null && tabConfig.compactOnResize) {
        // This tabs instance uses selectlist when small instead of tabs, we need to make sure it matches the current tab
        $('#' + tabFrameId + "-compact").val(triggerId);
      }
      if ($('#' + triggerId + "-box").length) {
        $('#' + tabFrameId + ' .tab-box').hide();
        $('#' + triggerId + "-box").show();
        if (progressBarExists) {
          progressBar.hide();
        }
        if (postRenderCallback !== undefined) {
          window[postRenderCallback]();
        } else {
          // Generic post render callback (applies to all tabs)
          if (tabConfig && tabConfig.postRenderCallback !== undefined) {
            var genericPostRenderCallback = tabConfig.postRenderCallback;
            if (typeof genericPostRenderCallback == "string") {
              window[genericPostRenderCallback]();
            } else {
              genericPostRenderCallback();
            }
          }
        }
        if (tabConfig && tabConfig.manipulateUrl === true) {
          this.ManipulateUrl();
        }
      } else {
        if (progressBarExists) {
          progressBar.show();
        }
        var fullPost = Object.assign({}, Post, dynamicData);
        $.ajax({
          url: url,
          type: 'POST',
          data: fullPost,
          success: function success(result) {
            var renderResult = true;
            var resultProcessed;

            // Call any post-data callbacks specified in tab config
            // Tab Specific post load callback, pass the result object as argument
            if (postProcessorCallback !== undefined) {
              var tabInstancePostCallback = postProcessorCallback;
              if (typeof tabInstancePostCallback == "string") {
                resultProcessed = window[tabInstancePostCallback](result);
              } else {
                resultProcessed = tabInstancePostCallback(result);
              }
            }
            // Generic post load callback (applies to all tabs)
            if (tabConfig && tabConfig.postLoadCallback !== undefined) {
              var callback = tabConfig.postLoadCallback;
              if (typeof callback == "string") {
                resultProcessed = window[callback](result);
              } else {
                resultProcessed = callback(result);
              }
            }

            // postProcessorCallback can halt the render process by return object
            // with bool field haltRendering = true
            if (_typeof(resultProcessed) == "object") {
              if (resultProcessed.hasOwnProperty("HaltRender")) {
                renderResult = false;
              }
            }

            // Render the tab if any data-post-processor-callback has not specified that 
            // rendering should be cancelled
            if (renderResult === true) {
              $('#tab-live-' + tabFrameId).remove();
              var dom = '<div class="tab-box" id="tab-live-' + tabFrameId + '">' + result + '</div>';
              $(tabFrame).append(dom);
            }
            if (progressBarExists) {
              progressBar.hide();
            }

            // Call any post-render callbacks specified in tab config

            // Tab Specific post render callback, pass the result object as argument
            if (postRenderCallback !== undefined) {
              var tabInstancePostRenderCallback = postRenderCallback;
              if (typeof tabInstancePostRenderCallback == "string") {
                window[tabInstancePostRenderCallback](result);
              } else {
                tabInstancePostRenderCallback(result);
              }
            }
            // Generic post render callback (applies to all tabs)
            if (tabConfig && tabConfig.postRenderCallback !== undefined) {
              var genericPostRenderCallback = tabConfig.postRenderCallback;
              if (typeof genericPostRenderCallback == "string") {
                window[genericPostRenderCallback]();
              } else {
                genericPostRenderCallback();
              }
            }
            if (tabConfig && tabConfig.manipulateUrl === true) {
              _this2.ManipulateUrl();
            }
          }
        });
      }
    }

    /*
     * Set the Browser bar URL to reflect current state of tabs on page
     */
  }, {
    key: "ManipulateUrl",
    value: function ManipulateUrl() {
      var vars = this.GetParameters();
      var out = "";
      for (var key in vars) {
        if (vars.hasOwnProperty(key)) {
          if (key !== 'tab') {
            if (out === "") {
              out += "?" + key + "=" + vars[key];
            } else {
              out += "&" + key + "=" + vars[key];
            }
          }
        }
      }

      // look for every active tab on the page (there is one per tabset)
      $('.frn-tab.frn-tab-active').each(function (index, element) {
        // get the parent frame and tabconfig data object for current active tab that we are checking
        var config = $(element).closest('.tab-frame').data('tab-config');
        // if a tab config oject is found
        if (config != undefined) {
          // if tab config for currently checking tabs has manipulateURL set to true 
          // (i.e. we want to incude this tab set in URL manipulation)
          if (config.manipulateUrl) {
            // Get the current URL parameters
            if (out === "") {
              out += "?tab=" + element.id.replace("tab-", "");
            } else {
              out += "&tab=" + element.id.replace("tab-", "");
            }
          }
        }
      });
      if (out !== "") {
        if (this.hash !== "" && this.hash != undefined) {
          out = out + this.hash;
        }
        window.history.pushState("", "", out);
      }
    }

    /*
     * Get the Id for the current Tab in a tabframe
     * IF stored locally, get that value, if not then return first tab
     */
  }, {
    key: "GetCurrentTab",
    value: function GetCurrentTab(frame) {
      var config = $(frame).data('tab-config');
      var localStoreName = config.localStoreName;
      var locallyStoredCurrentTab;
      var currentTab;
      var currentTabId;
      if (localStoreName !== null) {
        locallyStoredCurrentTab = localStorage.getItem(localStoreName + "-current-tab");
      }
      if (locallyStoredCurrentTab == null) {
        // Get First tab
        currentTab = $(frame + " .frn-tab:first");
        currentTabId = currentTab.prop('id');
      } else {
        currentTabId = locallyStoredCurrentTab;
      }
      return currentTabId;
    }
  }, {
    key: "SwitchSubTab",
    value: function SwitchSubTab(id, subTabId, callback) {
      var whitecard = $('.white-card.tab-' + subTabId + '-box').first();
      whitecard.removeClass(function (index, className) {
        return (className.match(/(^|\s)switch-class-\S+/g) || []).join(' ');
      });
      whitecard.addClass('switch-class-' + id);
      $('.frn-tab-' + subTabId).removeClass('frn-tab-active');
      $('#tab-' + id).parent().addClass('frn-tab-active');
      $('.sub-tab-' + subTabId).addClass('hide');
      $('.' + id).removeClass('hide');
      if (callback) {
        if (typeof callback == "string") {
          window[callback]();
        } else {
          callback();
        }
      }
    }
  }, {
    key: "SwitchTabSel",
    value: function SwitchTabSel() {
      var id = $('#tabSelect').val();
      $('.frn-tab').removeClass('frn-tab-active');
      $('#' + id).closest('div').addClass('frn-tab-active');
      $('.white-card').css('display', 'none');
      $('#' + id + '-box').css('display', 'block');
      $('.white-card.' + id + '-box').css('display', 'block');
      if (id === "tab-ref") {
        $('#referrals-filter').css('display', 'flex');
        $('#btnholder').css('display', 'block');
      } else {
        $('#referrals-filter').css('display', 'none');
        $('#btnholder').css('display', 'none');
      }
    }
  }, {
    key: "SwitchTab",
    value: function SwitchTab(id) {
      $('.frn-tab').removeClass('frn-tab-active');
      $('#' + id).parent().addClass('frn-tab-active');
      $('.tab-box').css('display', 'none');
      $('.' + id + '-box').css('display', 'block');
      if (id === "tab-ref") {
        $('#referrals-filter').css('display', 'flex');
        $('#btnholder').css('display', 'block');
      } else {
        $('#referrals-filter').css('display', 'none');
        $('#btnholder').css('display', 'none');
      }
      $('#tabSelect').val(id);
    }
  }, {
    key: "SwitchSignUpTabs",
    value: function SwitchSignUpTabs(tab, companyRep) {
      // CBF only: a client signup funnels into the onboarding flow rather than
      // the in-modal signup form. Company-rep signup keeps its own flow.
      if (tab === 'signup' && companyRep !== true && window.authSignupUrl) {
        window.location.href = window.authSignupUrl;
        return;
      }
      if (window.Access && window.Access.turnstile) {
        window.Access.turnstile.Reset();
      }
      if (window.Access && window.Access.tencentCaptcha) {
        window.Access.tencentCaptcha.Reset();
      }

      // Clear any existing Turnstile containers to prevent duplicates
      $('.cf-turnstile').remove();
      $('#loginModal .frn-tab').removeClass('frn-tab-active');
      if (tab == 'signup' && companyRep === true) {
        $("#sign-up-as-companyrep").prop('checked', true);
        $("#socialLoginList").hide();
        $("#socialLoginList~.or-wrap").hide();
      } else {
        $("#sign-up-as-companyrep").prop('checked', false);
        $("#socialLoginList").show();
        $("#socialLoginList~.or-wrap").show();
      }
      if (tab === "forgotten") {
        $('#login-tab').addClass('frn-tab-active');
        $('#forgot').hide();
      } else {
        $('#forgot').show();
        $('#' + tab + "-tab").addClass('frn-tab-active');
      }
      $('.signup-content').addClass('hide');
      $('#' + tab + "-payload").removeClass('hide');

      // Now render captcha for the active tab
      if (window.tencentCaptchaAppId && window.Access && window.Access.tencentCaptcha) {
        // CBFCN: pre-render Tencent captcha widget in the container
        window.Access.tencentCaptcha.Render(tab + '-tencent-container');
      } else if (window.Access && window.Access.turnstile) {
        // Other portals: load and render Turnstile in the container
        var turnstileContainerId = '#' + tab + '-turnstile-container';
        if ($(turnstileContainerId).length) {
          window.Access.turnstile.LoadTurnstile().then(function () {
            var token = window.Access.turnstile.GetToken();
            if (!token) {
              window.Access.turnstile.Render(turnstileContainerId, function (token) {
                console.log('Turnstile verified for ' + tab);
              });
            }
          })["catch"](function (err) {
            console.error('Failed to load Turnstile for ' + tab + ':', err);
          });
        }
      }
    }
  }, {
    key: "GetParameters",
    value: function GetParameters() {
      var qd = {};
      if (location.search) location.search.substr(1).split(_templateObject || (_templateObject = _taggedTemplateLiteral(["&"]))).forEach(function (item) {
        var _ref = item.split(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["="]))),
          _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];
        v = v && decodeURIComponent(v);
        (qd[k] = qd[k] || []).push(v);
      });
      return qd;
    }
  }]);
}();
var _default = exports["default"] = Tabs;

},{}]},{},[1]);
